import React from "react";
import Icon from "@ant-design/icons";

const Bell = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 5.33334C12 4.27247 11.5786 3.25505 10.8284 2.50491C10.0783 1.75476 9.06087 1.33334 8 1.33334C6.93913 1.33334 5.92172 1.75476 5.17157 2.50491C4.42143 3.25505 4 4.27247 4 5.33334C4 10 2 11.3333 2 11.3333H14C14 11.3333 12 10 12 5.33334Z"
      stroke="#403D39"
      strokeOpacity="0.6"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.15335 14C9.03614 14.2021 8.86791 14.3698 8.6655 14.4864C8.46309 14.6029 8.2336 14.6643 8.00001 14.6643C7.76643 14.6643 7.53694 14.6029 7.33453 14.4864C7.13212 14.3698 6.96389 14.2021 6.84668 14"
      stroke="#403D39"
      strokeOpacity="0.6"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const Divider = () => (
  <svg
    width="1"
    height="24"
    viewBox="0 0 1 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <line opacity="0.1" x1="0.5" y1="24" x2="0.5" stroke="black" />
  </svg>
);
const UserSvg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.6666 14V12.6667C12.6666 11.9594 12.3857 11.2811 11.8856 10.781C11.3855 10.281 10.7072 10 9.99998 10H5.99998C5.29274 10 4.61446 10.281 4.11436 10.781C3.61426 11.2811 3.33331 11.9594 3.33331 12.6667V14"
      stroke="#403D39"
      strokeOpacity="0.6"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.99998 7.33333C9.47274 7.33333 10.6666 6.13943 10.6666 4.66667C10.6666 3.19391 9.47274 2 7.99998 2C6.52722 2 5.33331 3.19391 5.33331 4.66667C5.33331 6.13943 6.52722 7.33333 7.99998 7.33333Z"
      stroke="#403D39"
      strokeOpacity="0.6"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const DashboardSvg = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.68028 8.20006H3.034C2.49898 8.1959 1.9841 8.39028 1.60265 8.74042C1.22119 9.09057 1.00441 9.56779 1 10.0671V17.1333C1.0099 18.1726 1.92037 19.0078 3.034 18.9992H6.68028C7.21531 19.0033 7.73018 18.8089 8.11164 18.4588C8.49309 18.1087 8.70987 17.6314 8.71428 17.1321V10.0671C8.70987 9.56779 8.49309 9.09057 8.11164 8.74042C7.73018 8.39028 7.21531 8.1959 6.68028 8.20006Z"
      stroke="#403D39"
      strokeOpacity="0.6"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.68028 1.00072H3.034C1.94276 0.972476 1.0329 1.77384 1 2.79218V4.00888C1.0329 5.02721 1.94276 5.82858 3.034 5.80033H6.68028C7.77153 5.82858 8.68139 5.02721 8.71428 4.00888V2.79218C8.68139 1.77384 7.77153 0.972476 6.68028 1.00072Z"
      stroke="#403D39"
      strokeOpacity="0.6"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.3197 11.7999H16.9647C17.4999 11.8044 18.0152 11.6101 18.3969 11.26C18.7786 10.9098 18.9956 10.4324 19 9.93286V2.86784C18.9956 2.36853 18.7788 1.89131 18.3973 1.54116C18.0159 1.19102 17.501 0.996643 16.966 1.0008H13.3197C12.7847 0.996643 12.2698 1.19102 11.8884 1.54116C11.5069 1.89131 11.2901 2.36853 11.2857 2.86784V9.93286C11.2901 10.4322 11.5069 10.9094 11.8884 11.2595C12.2698 11.6097 12.7847 11.8041 13.3197 11.7999Z"
      stroke="#403D39"
      strokeOpacity="0.6"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.3197 18.9992H16.9647C18.0564 19.0282 18.9671 18.2266 19 17.2078V15.9911C18.9671 14.9728 18.0572 14.1714 16.966 14.1996H13.3197C12.2285 14.1714 11.3186 14.9728 11.2857 15.9911V17.2066C11.3179 18.2254 12.228 19.0275 13.3197 18.9992Z"
      stroke="#403D39"
      strokeOpacity="0.6"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const LoginLogoSvg = () => (
  <svg
    width="251"
    height="122"
    viewBox="0 0 172 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M70.6 19.003H74.4544V21.4885H74.5162C75.0934 20.4204 75.8766 19.6603 76.9069 19.2084C77.9377 18.7565 79.0298 18.51 80.2257 18.51C81.6681 18.51 82.946 18.7565 84.0178 19.27C85.0896 19.7836 85.9964 20.482 86.6971 21.3652C87.4186 22.2485 87.934 23.2961 88.3051 24.467C88.6555 25.6584 88.8408 26.9114 88.8408 28.2671C88.8408 29.4996 88.6762 30.6911 88.3669 31.8619C88.0373 33.0122 87.5629 34.0393 86.9037 34.9226C86.244 35.8058 85.4192 36.5248 84.4299 37.0589C83.4406 37.593 82.266 37.86 80.9056 37.86C80.3077 37.86 79.7103 37.7984 79.1331 37.6957C78.5352 37.593 77.9788 37.4081 77.4223 37.1821C76.8659 36.9562 76.3713 36.648 75.9176 36.2783C75.4645 35.9086 75.0726 35.4772 74.7638 34.9842H74.7015V44.1456H70.6416V19.003H70.6ZM84.7803 28.2055C84.7803 27.3839 84.6775 26.5827 84.4507 25.8022C84.2446 25.0216 83.9151 24.3232 83.4822 23.7275C83.0493 23.1318 82.5131 22.6388 81.8742 22.2691C81.2352 21.8994 80.4935 21.7145 79.6693 21.7145C77.9585 21.7145 76.6806 22.3102 75.8149 23.481C74.9491 24.6724 74.5162 26.2336 74.5162 28.2055C74.5162 29.1299 74.6195 29.9926 74.8458 30.7732C75.0726 31.5743 75.4027 32.2522 75.8559 32.8068C76.3095 33.382 76.8452 33.8339 77.4841 34.1626C78.123 34.4912 78.8445 34.6555 79.6693 34.6555C80.5963 34.6555 81.3795 34.4707 82.0185 34.0804C82.6574 33.7106 83.1936 33.2176 83.6057 32.6014C84.0178 32.0057 84.3272 31.3073 84.4922 30.5473C84.6983 29.7872 84.7803 29.0067 84.7803 28.2055Z"
      fill="#001219"
    />
    <path
      d="M107.574 37.4657H103.554V34.8991H103.492C102.994 35.8305 102.248 36.5756 101.254 37.1345C100.259 37.6933 99.2642 37.9831 98.2277 37.9831C95.803 37.9831 94.0415 37.3828 92.9429 36.1824C91.8652 34.9818 91.3057 33.1604 91.3057 30.7387V19.0029H95.3886V30.3455C95.3886 31.9599 95.6991 33.119 96.3212 33.7814C96.9428 34.4437 97.8133 34.7749 98.9323 34.7749C99.782 34.7749 100.507 34.6507 101.088 34.3816C101.668 34.1125 102.124 33.7607 102.476 33.326C102.829 32.8914 103.098 32.3532 103.243 31.7322C103.388 31.1113 103.471 30.4489 103.471 29.7245V19.0029H107.554V37.4657H107.574Z"
      fill="#001219"
    />
    <path
      d="M111.025 19.0003H114.854V22.5346H114.916C115.04 22.0443 115.268 21.554 115.62 21.0841C115.972 20.6142 116.386 20.1852 116.862 19.7971C117.358 19.4089 117.897 19.1025 118.497 18.8573C119.097 18.6326 119.697 18.51 120.319 18.51C120.794 18.51 121.125 18.5304 121.312 18.5509C121.498 18.5713 121.684 18.5917 121.871 18.6121V22.4937C121.581 22.4528 121.291 22.412 121.001 22.3712C120.712 22.3303 120.401 22.3099 120.132 22.3099C119.449 22.3099 118.787 22.4528 118.186 22.7185C117.586 22.984 117.048 23.3926 116.593 23.9238C116.137 24.455 115.785 25.1087 115.516 25.885C115.247 26.6613 115.123 27.5602 115.123 28.5612V37.2437H111.046V19.0003H111.025Z"
      fill="#001219"
    />
    <path
      d="M125.972 29.2688C125.972 29.9916 126.075 30.6731 126.282 31.3339C126.49 31.9947 126.779 32.5729 127.194 33.0891C127.608 33.5847 128.105 33.9977 128.726 34.2868C129.348 34.576 130.093 34.7411 130.942 34.7411C132.143 34.7411 133.096 34.4933 133.821 33.9771C134.546 33.4609 135.084 32.6968 135.457 31.6849H139.33C139.123 32.6761 138.75 33.5847 138.212 34.3695C137.694 35.1541 137.052 35.8149 136.306 36.3519C135.561 36.8888 134.732 37.3018 133.821 37.5702C132.91 37.8387 131.936 37.9832 130.942 37.9832C129.493 37.9832 128.208 37.7354 127.069 37.2605C125.951 36.7855 124.998 36.1247 124.232 35.2574C123.466 34.4108 122.865 33.3782 122.472 32.1805C122.078 30.9828 121.871 29.6818 121.871 28.2569C121.871 26.956 122.078 25.6963 122.492 24.5193C122.907 23.3422 123.507 22.3097 124.273 21.4217C125.04 20.5338 125.992 19.8316 127.09 19.2947C128.188 18.7785 129.43 18.51 130.818 18.51C132.268 18.51 133.573 18.8198 134.732 19.4187C135.892 20.0175 136.845 20.8229 137.611 21.8347C138.377 22.8259 138.937 23.9824 139.268 25.2833C139.62 26.5843 139.703 27.9266 139.537 29.2895H125.972V29.2688ZM135.499 26.5843C135.457 25.9441 135.312 25.3246 135.084 24.7258C134.857 24.1269 134.546 23.6107 134.152 23.177C133.759 22.7433 133.283 22.3716 132.723 22.1032C132.164 21.8347 131.543 21.6902 130.839 21.6902C130.114 21.6902 129.472 21.8141 128.892 22.0619C128.312 22.3097 127.815 22.6608 127.38 23.0944C126.966 23.5281 126.634 24.0443 126.386 24.6432C126.137 25.242 125.992 25.8822 125.972 26.5637H135.499V26.5843Z"
      fill="#001219"
    />
    <path
      d="M143.224 19.0029L147.889 34.8372H147.951L152.411 19.0029H154.927L159.388 34.8372H159.449L164.114 19.0029H166.487L160.615 37.4901H158.18L153.7 21.9459H153.638L149.178 37.4901H146.723L140.851 19.0029H143.224Z"
      fill="#001219"
    />
    <path d="M171.17 11.8544V37.49H168.952V11.8544H171.17Z" fill="#001219" />
    <path
      d="M57.0131 28.0001C57.0131 35.7389 53.8646 42.7312 48.7906 47.8044C43.7162 52.8772 36.6856 56 28.9213 56C21.1571 56 14.1418 52.8619 9.05221 47.8044C3.96267 42.7466 0.829468 35.7389 0.829468 28.0001C0.829468 20.2612 3.97796 13.2688 9.05221 8.19587C14.1265 3.12297 21.1571 0 28.9213 0C36.6856 0 43.7008 3.1382 48.7906 8.19587C53.88 13.2536 57.0131 20.2612 57.0131 28.0001Z"
      fill="#6F5BF6"
    />
    <path
      d="M13.1249 12.641C16.6779 9.42001 23.784 7.1608 28.9604 7.1608C34.1368 7.1608 41.3961 9.2521 44.7958 12.641C47.9201 15.0681 50.0949 18.8843 50.5847 22.9295C50.6156 23.1891 50.6461 23.4638 50.6769 23.7233C50.7992 25.0666 50.7992 26.4405 50.692 27.8601C50.5388 30.7605 49.8497 33.5234 48.7166 36.0574C47.629 38.4845 46.1129 40.6826 44.3365 42.6062C43.969 43.0029 43.6014 43.3846 43.2184 43.7663C42.4834 44.4837 41.7328 45.1552 40.8601 45.7203C40.5689 45.9187 40.2627 46.1017 39.941 46.2543C39.4663 46.468 39.0069 46.6056 38.5475 46.7429C38.0727 46.8801 37.5673 46.9412 37.1079 47.0789C36.3881 47.2926 35.4845 47.2468 34.7341 47.3687C32.9729 47.6589 30.8748 47.5213 28.7613 47.5978C25.4686 47.7201 22.9264 47.9488 20.1697 47.2926C19.8481 47.2161 19.5112 47.1246 19.1896 46.987C19.0058 46.9109 18.822 46.8194 18.6536 46.7275C16.5707 45.5981 14.9014 43.9951 13.3393 42.2856C9.66377 38.2861 7.22869 33.0655 6.92239 27.3258C6.90708 26.9595 6.89177 26.6084 6.89177 26.2421C6.78459 20.823 9.41872 15.9839 13.1249 12.641Z"
      fill="#9F92F8"
    />
    <path
      d="M17.1327 17.0611C19.0584 15.6225 26.2873 14.3216 28.8854 14.3216C31.4835 14.3216 38.9416 15.3776 40.638 17.0611C43.2209 18.2702 44.9324 21.3005 44.688 24.2237C44.6726 24.4074 44.6576 24.6063 44.6422 24.79C44.5352 25.7389 44.3824 26.7184 44.1685 27.6979C43.8629 29.5344 43.2971 31.3251 42.5027 32.978C41.7538 34.5544 40.7754 36.0083 39.6905 37.3551C39.4307 37.6765 39.1861 37.9979 38.911 38.3193C38.4067 38.9314 37.8871 39.4979 37.2146 39.9569C36.9854 40.11 36.7408 40.2476 36.4811 40.3242C36.099 40.4314 35.7475 40.3855 35.4112 40.3547C35.0597 40.3242 34.7235 40.2476 34.4178 40.1558C34.0663 40.2938 33.241 39.5284 32.8742 39.6355C31.7127 39.1765 30.0927 38.9163 28.4574 39.0693C25.844 39.3141 24.5297 40.5844 22.4359 40.7528C22.1914 40.7682 21.9316 40.7682 21.6718 40.6916C21.5189 40.6457 21.3814 40.569 21.2591 40.4927C19.6697 39.5588 18.6305 38.0591 17.5453 36.6511C15.2835 33.7585 13.5718 30.2997 12.9451 26.55C12.8993 26.3051 12.8687 26.0756 12.8382 25.8307C12.3339 22.2341 14.4582 19.0507 17.1327 17.0611Z"
      fill="#CFC8FB"
    />
    <path
      d="M36.6733 21.6653H21.1524C19.1159 21.6653 17.8199 23.7909 18.7764 25.5396C19.7793 27.3637 20.7667 29.1878 21.7696 31.0118C22.3713 32.1274 22.8032 33.454 23.9295 34.1927C24.0221 34.253 24.1146 34.3133 24.2381 34.3284C24.4386 34.3585 24.6392 34.2681 24.7935 34.1475C26.2438 33.1525 26.3363 30.9063 28.2957 30.5445C29.4528 30.3335 30.6254 30.8762 31.1808 31.8862L31.9059 33.1977C32.0448 33.4691 32.2454 33.6952 32.4768 33.9062C32.6773 34.0872 32.9396 34.3133 33.2328 34.3133C33.4333 34.3133 33.6185 34.2228 33.7727 34.1173C34.2664 33.7857 34.5287 33.3183 34.8219 32.8209C34.9762 32.5646 35.115 32.3083 35.2693 32.0671C35.6858 31.3435 36.1024 30.635 36.5344 29.9114C36.9818 29.1425 37.4447 28.3586 37.8921 27.5898C38.2161 27.0321 38.5401 26.4894 38.8641 25.9316C38.9258 25.826 38.9875 25.7205 39.0492 25.5999C40.0366 23.8512 38.7407 21.6653 36.6733 21.6653Z"
      fill="white"
    />
  </svg>
);
const MenuSvg = () => (
  <svg
    width="4"
    height="16"
    viewBox="0 0 4 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.00002 2.40001C2.3314 2.40001 2.60002 2.13138 2.60002 1.80001C2.60002 1.46864 2.3314 1.20001 2.00002 1.20001C1.66865 1.20001 1.40002 1.46864 1.40002 1.80001C1.40002 2.13138 1.66865 2.40001 2.00002 2.40001Z"
      stroke="#8D95A0"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.00002 8.60002C2.3314 8.60002 2.60002 8.3314 2.60002 8.00002C2.60002 7.66865 2.3314 7.40002 2.00002 7.40002C1.66865 7.40002 1.40002 7.66865 1.40002 8.00002C1.40002 8.3314 1.66865 8.60002 2.00002 8.60002Z"
      stroke="#8D95A0"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.00002 14.8C2.3314 14.8 2.60002 14.5314 2.60002 14.2C2.60002 13.8686 2.3314 13.6 2.00002 13.6C1.66865 13.6 1.40002 13.8686 1.40002 14.2C1.40002 14.5314 1.66865 14.8 2.00002 14.8Z"
      stroke="#8D95A0"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const SearchSvg = () => (
  <svg
    width="35"
    height="35"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="24" height="24" rx="4" fill="#AAE6F2" fillOpacity="0.2" />
    <path
      d="M11.3333 16.6667C14.2789 16.6667 16.6667 14.2789 16.6667 11.3333C16.6667 8.38781 14.2789 6 11.3333 6C8.38781 6 6 8.38781 6 11.3333C6 14.2789 8.38781 16.6667 11.3333 16.6667Z"
      stroke="#7D858F"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18 18L15.1 15.1"
      stroke="#7D858F"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const invoiceSvg = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_3048_628)">
      <path
        d="M9 7H15M9 11H15M13 15H15M5 21V5C5 4.46957 5.21071 3.96086 5.58579 3.58579C5.96086 3.21071 6.46957 3 7 3H17C17.5304 3 18.0391 3.21071 18.4142 3.58579C18.7893 3.96086 19 4.46957 19 5V21L16 19L14 21L12 19L10 21L8 19L5 21Z"
        stroke="#7D858F"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3048_628">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
const LifeGuard = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.00001 14.6667C11.6819 14.6667 14.6667 11.6819 14.6667 8C14.6667 4.3181 11.6819 1.33334 8.00001 1.33334C4.31811 1.33334 1.33334 4.3181 1.33334 8C1.33334 11.6819 4.31811 14.6667 8.00001 14.6667Z"
      stroke="#403D39"
      strokeOpacity="0.6"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.00001 10.6667C9.47277 10.6667 10.6667 9.47276 10.6667 8C10.6667 6.52724 9.47277 5.33334 8.00001 5.33334C6.52725 5.33334 5.33334 6.52724 5.33334 8C5.33334 9.47276 6.52725 10.6667 8.00001 10.6667Z"
      stroke="#403D39"
      strokeOpacity="0.6"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.28665 3.28667L6.11332 6.11333"
      stroke="#403D39"
      strokeOpacity="0.6"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.88666 9.88667L12.7133 12.7133"
      stroke="#403D39"
      strokeOpacity="0.6"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.88666 6.11333L12.7133 3.28667"
      stroke="#403D39"
      strokeOpacity="0.6"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.88666 6.11334L12.24 3.76"
      stroke="#403D39"
      strokeOpacity="0.6"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.28665 12.7133L6.11332 9.88667"
      stroke="#403D39"
      strokeOpacity="0.6"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const UsersSvg = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 21V19C16 17.9391 15.5786 16.9217 14.8284 16.1716C14.0783 15.4214 13.0609 15 12 15H6C4.93913 15 3.92172 15.4214 3.17157 16.1716C2.42143 16.9217 2 17.9391 2 19V21"
      stroke="#403D39"
      strokeOpacity="0.6"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z"
      stroke="#403D39"
      strokeOpacity="0.6"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22 21V19C21.9993 18.1137 21.7044 17.2528 21.1614 16.5523C20.6184 15.8519 19.8581 15.3516 19 15.13"
      stroke="#403D39"
      strokeOpacity="0.6"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 3.13C16.8604 3.35031 17.623 3.85071 18.1676 4.55232C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89318 18.7122 8.75608 18.1676 9.45769C17.623 10.1593 16.8604 10.6597 16 10.88"
      stroke="#403D39"
      strokeOpacity="0.6"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const DashboardActSvg = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.0010376 5.12122C0.0010376 3.46436 1.34418 2.12122 3.00104 2.12122H13.2347C14.8915 2.12122 16.2347 3.46436 16.2347 5.12122V15.3548C16.2347 17.0117 14.8915 18.3548 13.2347 18.3548H3.00104C1.34419 18.3548 0.0010376 17.0117 0.0010376 15.3548V5.12122ZM0.0010376 26.7664C0.0010376 25.1095 1.34418 23.7664 3.00104 23.7664H13.2347C14.8915 23.7664 16.2347 25.1095 16.2347 26.7664V37C16.2347 38.6569 14.8915 40 13.2347 40H3.00104C1.34419 40 0.0010376 38.6569 0.0010376 37V26.7664ZM21.6462 26.7664C21.6462 25.1095 22.9894 23.7664 24.6462 23.7664H34.8798C36.5367 23.7664 37.8798 25.1095 37.8798 26.7664V37C37.8798 38.6569 36.5367 40 34.8798 40H24.6462C22.9894 40 21.6462 38.6569 21.6462 37V26.7664Z"
      fill="url(#paint0_linear_316_755)"
    />
    <path
      d="M27.6401 2.12132L21.6453 8.11619C20.4737 9.28776 20.4737 11.1873 21.6453 12.3588L27.6401 18.3537C28.8117 19.5253 30.7112 19.5253 31.8828 18.3537L37.8777 12.3588C39.0492 11.1873 39.0492 9.28776 37.8777 8.11619L31.8828 2.12132C30.7112 0.949747 28.8117 0.949748 27.6401 2.12132Z"
      fill="url(#paint1_linear_316_755)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_316_755"
        x1="30.5699"
        y1="2.12121"
        x2="18.9404"
        y2="40"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0480236" stopColor="#B9B1E4" />
        <stop offset="1" stopColor="#F6F4FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_316_755"
        x1="32.5329"
        y1="8.94829e-08"
        x2="29.7615"
        y2="20.475"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFA96F" />
        <stop offset="1" stopColor="#FFF9F4" />
      </linearGradient>
    </defs>
  </svg>
);

const DashboardNewAccSvg = () => (
  <svg
    width="36"
    height="40"
    viewBox="0 0 36 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M35.0801 40V35.12C35.0801 32.5314 34.0519 30.0489 32.2215 28.2186C30.3911 26.3882 27.9086 25.3599 25.3201 25.3599H10.68C8.09146 25.3599 5.60894 26.3882 3.77858 28.2186C1.94821 30.0489 0.919922 32.5314 0.919922 35.12V40"
      fill="url(#paint0_linear_316_754)"
    />
    <path
      d="M18.0001 19.5201C23.3904 19.5201 27.7601 15.1504 27.7601 9.76006C27.7601 4.36973 23.3904 0 18.0001 0C12.6097 0 8.23999 4.36973 8.23999 9.76006C8.23999 15.1504 12.6097 19.5201 18.0001 19.5201Z"
      fill="url(#paint1_linear_316_754)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_316_754"
        x1="37.1954"
        y1="17.2842"
        x2="31.7073"
        y2="42.933"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0480236" stopColor="#B9B1E4" />
        <stop offset="1" stopColor="#F6F4FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_316_754"
        x1="30.573"
        y1="-5.69967"
        x2="18.0001"
        y2="19.5201"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFA96F" />
        <stop offset="1" stopColor="#FFF9F4" />
      </linearGradient>
    </defs>
  </svg>
);
const ExpireTimeSvg = () => (
  <svg
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_695_3821)">
      <path
        d="M15.75 9.34375C16.1016 9.58398 16.415 9.85645 16.6904 10.1611C16.9658 10.4658 17.2031 10.7998 17.4023 11.1631C17.6016 11.5264 17.748 11.9102 17.8418 12.3145C17.9355 12.7188 17.9883 13.1318 18 13.5537C18 14.251 17.8682 14.9072 17.6045 15.5225C17.3408 16.1377 16.9775 16.6738 16.5146 17.1309C16.0518 17.5879 15.5156 17.9482 14.9062 18.2119C14.2969 18.4756 13.6406 18.6104 12.9375 18.6162C12.4043 18.6162 11.8887 18.5371 11.3906 18.3789C10.8926 18.2207 10.4355 17.9922 10.0195 17.6934C9.60352 17.3945 9.23438 17.0371 8.91211 16.6211C8.58984 16.2051 8.34082 15.7451 8.16504 15.2412H1.125V1.74121H3.375V0.616211H4.5V1.74121H12.375V0.616211H13.5V1.74121H15.75V9.34375ZM2.25 2.86621V5.11621H14.625V2.86621H13.5V3.99121H12.375V2.86621H4.5V3.99121H3.375V2.86621H2.25ZM7.90137 14.1162C7.88379 13.9346 7.875 13.7471 7.875 13.5537C7.875 12.8564 8.00684 12.2002 8.27051 11.585C8.53418 10.9697 8.89746 10.4336 9.36035 9.97656C9.82324 9.51953 10.3594 9.15918 10.9688 8.89551C11.5781 8.63184 12.2344 8.49707 12.9375 8.49121C13.5234 8.49121 14.0859 8.58789 14.625 8.78125V6.24121H2.25V14.1162H7.90137ZM12.9375 17.4912C13.4824 17.4912 13.9922 17.3887 14.4668 17.1836C14.9414 16.9785 15.3574 16.6973 15.7148 16.3398C16.0723 15.9824 16.3535 15.5664 16.5586 15.0918C16.7637 14.6172 16.8691 14.1045 16.875 13.5537C16.875 13.0088 16.7725 12.499 16.5674 12.0244C16.3623 11.5498 16.0811 11.1338 15.7236 10.7764C15.3662 10.4189 14.9502 10.1377 14.4756 9.93262C14.001 9.72754 13.4883 9.62207 12.9375 9.61621C12.3926 9.61621 11.8828 9.71875 11.4082 9.92383C10.9336 10.1289 10.5176 10.4102 10.1602 10.7676C9.80273 11.125 9.52148 11.541 9.31641 12.0156C9.11133 12.4902 9.00586 13.0029 9 13.5537C9 14.0986 9.10254 14.6084 9.30762 15.083C9.5127 15.5576 9.79395 15.9736 10.1514 16.3311C10.5088 16.6885 10.9248 16.9697 11.3994 17.1748C11.874 17.3799 12.3867 17.4854 12.9375 17.4912ZM13.5 12.9912H15.1875V14.1162H12.375V10.7412H13.5V12.9912Z"
        fill="#6F5BF6"
      />
    </g>
    <defs>
      <clipPath id="clip0_695_3821">
        <rect
          width="18"
          height="18"
          fill="white"
          transform="translate(0 0.616211)"
        />
      </clipPath>
    </defs>
  </svg>
);
const EmailSvg = () => (
  <svg
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.5 5.11621C16.5 4.29121 15.825 3.61621 15 3.61621H3C2.175 3.61621 1.5 4.29121 1.5 5.11621V14.1162C1.5 14.9412 2.175 15.6162 3 15.6162H15C15.825 15.6162 16.5 14.9412 16.5 14.1162V5.11621ZM15 5.11621L9 8.86621L3 5.11621H15ZM15 14.1162H3V6.61621L9 10.3662L15 6.61621V14.1162Z"
      fill="#6F5BF6"
    />
  </svg>
);

const MultiLoginSvg = () => (
  <svg
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.7766 9.19234C10.1178 9.19234 9.47376 8.99698 8.92597 8.63096C8.37819 8.26494 7.95124 7.74471 7.69912 7.13604C7.447 6.52737 7.38104 5.85761 7.50957 5.21146C7.63809 4.5653 7.95535 3.97177 8.4212 3.50591C8.88705 3.04006 9.48059 2.72281 10.1267 2.59428C10.7729 2.46575 11.4427 2.53172 12.0513 2.78383C12.66 3.03595 13.1802 3.4629 13.5462 4.01069C13.9123 4.55847 14.1076 5.20249 14.1076 5.86131C14.1076 6.74475 13.7567 7.59202 13.132 8.21671C12.5073 8.8414 11.66 9.19234 10.7766 9.19234ZM10.7766 3.86269C10.3813 3.86269 9.99489 3.97991 9.66622 4.19952C9.33755 4.41913 9.08138 4.73127 8.93011 5.09647C8.77884 5.46167 8.73926 5.86353 8.81638 6.25122C8.89349 6.63891 9.08385 6.99503 9.36336 7.27455C9.64287 7.55406 9.99899 7.74441 10.3867 7.82153C10.7744 7.89864 11.1762 7.85906 11.5414 7.70779C11.9066 7.55652 12.2188 7.30035 12.4384 6.97168C12.658 6.64301 12.7752 6.2566 12.7752 5.86131C12.7752 5.33124 12.5646 4.82288 12.1898 4.44807C11.815 4.07326 11.3067 3.86269 10.7766 3.86269ZM16.9945 16.4103C16.8186 16.408 16.6504 16.337 16.526 16.2126C16.4015 16.0882 16.3306 15.92 16.3283 15.7441C16.3283 14.0119 15.3867 11.8572 10.7766 11.8572C6.16644 11.8572 5.22487 14.0119 5.22487 15.7441C5.22487 15.9208 5.15468 16.0902 5.02974 16.2151C4.90481 16.3401 4.73535 16.4103 4.55867 16.4103C4.38198 16.4103 4.21252 16.3401 4.08759 16.2151C3.96265 16.0902 3.89246 15.9208 3.89246 15.7441C3.89246 11.5248 8.7158 10.5248 10.7766 10.5248C12.8374 10.5248 17.6607 11.5248 17.6607 15.7441C17.6584 15.92 17.5875 16.0882 17.4631 16.2126C17.3386 16.337 17.1705 16.408 16.9945 16.4103ZM5.73119 9.91185H5.44694C4.74018 9.84353 4.08952 9.49725 3.63807 8.94919C3.18663 8.40112 2.97139 7.69618 3.03971 6.98942C3.10803 6.28266 3.45431 5.63199 4.00237 5.18055C4.55044 4.72911 5.25538 4.51387 5.96214 4.58219C6.05276 4.58609 6.14163 4.60845 6.22331 4.6479C6.30498 4.68735 6.37774 4.74307 6.43713 4.81163C6.49651 4.8802 6.54126 4.96017 6.56865 5.04664C6.59604 5.13311 6.60548 5.22427 6.59639 5.31451C6.58731 5.40476 6.55989 5.49221 6.51581 5.57149C6.47174 5.65076 6.41194 5.72021 6.34009 5.77556C6.26823 5.83091 6.18582 5.87101 6.09792 5.89339C6.01002 5.91577 5.91848 5.91997 5.8289 5.90572C5.6555 5.88843 5.48039 5.90627 5.31404 5.95816C5.14769 6.01005 4.9935 6.09493 4.86068 6.20774C4.72577 6.31655 4.61388 6.45114 4.53153 6.60364C4.44918 6.75615 4.39801 6.92353 4.38101 7.09601C4.36264 7.27066 4.37921 7.44722 4.42976 7.6154C4.48031 7.78358 4.56382 7.94002 4.67543 8.0756C4.78704 8.21119 4.92451 8.32321 5.07984 8.40513C5.23518 8.48705 5.40526 8.53725 5.58018 8.55278C5.86935 8.57752 6.15884 8.50904 6.40628 8.35736C6.55705 8.26431 6.73862 8.23496 6.91103 8.27577C7.08345 8.31658 7.23259 8.42422 7.32564 8.57499C7.4187 8.72577 7.44805 8.90733 7.40724 9.07975C7.36642 9.25216 7.25879 9.4013 7.10802 9.49436C6.69603 9.75712 6.21973 9.90155 5.73119 9.91185ZM1.00556 14.7441C0.829589 14.7418 0.66147 14.6708 0.537027 14.5464C0.412584 14.422 0.341656 14.2538 0.339355 14.0779C0.339355 11.6795 0.978914 10.0806 4.11453 10.0806C4.29122 10.0806 4.46067 10.1508 4.58561 10.2757C4.71054 10.4007 4.78073 10.5701 4.78073 10.7468C4.78073 10.9235 4.71054 11.093 4.58561 11.2179C4.46067 11.3428 4.29122 11.413 4.11453 11.413C2.02708 11.413 1.67177 12.0792 1.67177 14.0779C1.66947 14.2538 1.59854 14.422 1.4741 14.5464C1.34965 14.6708 1.18154 14.7418 1.00556 14.7441Z"
      fill="#6F5BF6"
    />
  </svg>
);

const ClockSvg = () => (
  <svg
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_695_3826)">
      <path
        d="M9 1.97021C13.1422 1.97021 16.5 5.32797 16.5 9.47021C16.5 13.6125 13.1422 16.9702 9 16.9702C4.85775 16.9702 1.5 13.6125 1.5 9.47021C1.5 5.32797 4.85775 1.97021 9 1.97021ZM9 3.47021C7.4087 3.47021 5.88258 4.10236 4.75736 5.22757C3.63214 6.35279 3 7.87892 3 9.47021C3 11.0615 3.63214 12.5876 4.75736 13.7129C5.88258 14.8381 7.4087 15.4702 9 15.4702C10.5913 15.4702 12.1174 14.8381 13.2426 13.7129C14.3679 12.5876 15 11.0615 15 9.47021C15 7.87892 14.3679 6.35279 13.2426 5.22757C12.1174 4.10236 10.5913 3.47021 9 3.47021ZM9 4.97021C9.1837 4.97024 9.361 5.03768 9.49828 5.15975C9.63556 5.28182 9.72326 5.45003 9.74475 5.63246L9.75 5.72021V9.15972L11.7802 11.19C11.9148 11.3249 11.9929 11.506 11.9987 11.6965C12.0045 11.887 11.9376 12.0725 11.8116 12.2154C11.6855 12.3583 11.5098 12.4479 11.3201 12.466C11.1305 12.4841 10.941 12.4293 10.7903 12.3127L10.7198 12.2505L8.46975 10.0005C8.35318 9.8838 8.27832 9.73197 8.25675 9.56846L8.25 9.47021V5.72021C8.25 5.5213 8.32902 5.33054 8.46967 5.18988C8.61032 5.04923 8.80109 4.97021 9 4.97021Z"
        fill="#6F5BF6"
      />
    </g>
    <defs>
      <clipPath id="clip0_695_3826">
        <rect
          width="18"
          height="18"
          fill="white"
          transform="translate(0 0.470215)"
        />
      </clipPath>
    </defs>
  </svg>
);

const UserNavSvg = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 21V19C19 17.9391 18.5786 16.9217 17.8284 16.1716C17.0783 15.4214 16.0609 15 15 15H9C7.93913 15 6.92172 15.4214 6.17157 16.1716C5.42143 16.9217 5 17.9391 5 19V21"
      stroke="#A19CB9"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z"
      stroke="#A19CB9"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const WorldSvg = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 1.6875C7.55373 1.6875 6.13993 2.11637 4.9374 2.91988C3.73486 3.72339 2.7976 4.86544 2.24413 6.20163C1.69067 7.53781 1.54586 9.00811 1.82801 10.4266C2.11017 11.8451 2.80661 13.148 3.82928 14.1707C4.85196 15.1934 6.15492 15.8898 7.57341 16.172C8.99189 16.4541 10.4622 16.3093 11.7984 15.7559C13.1346 15.2024 14.2766 14.2651 15.0801 13.0626C15.8836 11.8601 16.3125 10.4463 16.3125 9C16.3105 7.06123 15.5394 5.20246 14.1685 3.83154C12.7975 2.46063 10.9388 1.68955 9 1.6875ZM7.14586 11.8125H10.8541C10.4766 13.102 9.84375 14.2643 9 15.1798C8.15625 14.2643 7.52344 13.102 7.14586 11.8125ZM6.89063 10.6875C6.70407 9.57023 6.70407 8.42977 6.89063 7.3125H11.1094C11.2959 8.42977 11.2959 9.57023 11.1094 10.6875H6.89063ZM2.8125 9C2.81201 8.42937 2.89081 7.86144 3.04664 7.3125H5.75086C5.58305 8.43124 5.58305 9.56876 5.75086 10.6875H3.04664C2.89081 10.1386 2.81201 9.57063 2.8125 9ZM10.8541 6.1875H7.14586C7.52344 4.89797 8.15625 3.7357 9 2.82023C9.84375 3.7357 10.4766 4.89797 10.8541 6.1875ZM12.2491 7.3125H14.9534C15.2656 8.41584 15.2656 9.58416 14.9534 10.6875H12.2491C12.417 9.56876 12.417 8.43124 12.2491 7.3125ZM14.5104 6.1875H12.0192C11.7322 5.05794 11.2501 3.98717 10.5947 3.02344C11.432 3.24845 12.213 3.64621 12.8873 4.19114C13.5617 4.73606 14.1146 5.4161 14.5104 6.1875ZM7.40532 3.02344C6.74993 3.98717 6.26785 5.05794 5.98078 6.1875H3.48961C3.88542 5.4161 4.43829 4.73606 5.11267 4.19114C5.78704 3.64621 6.568 3.24845 7.40532 3.02344ZM3.48961 11.8125H5.98078C6.26785 12.9421 6.74993 14.0128 7.40532 14.9766C6.568 14.7515 5.78704 14.3538 5.11267 13.8089C4.43829 13.2639 3.88542 12.5839 3.48961 11.8125ZM10.5947 14.9766C11.2501 14.0128 11.7322 12.9421 12.0192 11.8125H14.5104C14.1146 12.5839 13.5617 13.2639 12.8873 13.8089C12.213 14.3538 11.432 14.7515 10.5947 14.9766Z"
      fill="#6F5BF6"
    />
  </svg>
);

const DownloadSDKSvg = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1040_1108)">
      <g clipPath="url(#clip1_1040_1108)">
        <path
          d="M14 8C15.1046 8 16 7.10457 16 6C16 4.89543 15.1046 4 14 4C12.8954 4 12 4.89543 12 6C12 7.10457 12.8954 8 14 8Z"
          fill="#A19CB9"
          stroke="#A19CB9"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4 6H12"
          stroke="#A19CB9"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16 6H20"
          stroke="#A19CB9"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 14C9.10457 14 10 13.1046 10 12C10 10.8954 9.10457 10 8 10C6.89543 10 6 10.8954 6 12C6 13.1046 6.89543 14 8 14Z"
          fill="#A19CB9"
          stroke="#A19CB9"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4 12H6"
          stroke="#A19CB9"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 12H20"
          stroke="#A19CB9"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17 20C18.1046 20 19 19.1046 19 18C19 16.8954 18.1046 16 17 16C15.8954 16 15 16.8954 15 18C15 19.1046 15.8954 20 17 20Z"
          fill="#A19CB9"
          stroke="#A19CB9"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4 18H15"
          stroke="#A19CB9"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19 18H20"
          stroke="#A19CB9"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1040_1108">
        <rect width="24" height="24" fill="white" />
      </clipPath>
      <clipPath id="clip1_1040_1108">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const ReportsSvg = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 20H20M6 16H9C9.55228 16 10 15.5523 10 15V9C10 8.44772 9.55228 8 9 8H6C5.44772 8 5 8.44772 5 9V15C5 15.5523 5.44772 16 6 16ZM15 16H18C18.5523 16 19 15.5523 19 15V5C19 4.44772 18.5523 4 18 4H15C14.4477 4 14 4.44772 14 5V15C14 15.5523 14.4477 16 15 16Z"
      stroke="#7D858F"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const KeySvg = () => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.3212 10.6852L4 19L6 21M7 16L9 18M20 7.5C20 9.98528 17.9853 12 15.5 12C13.0147 12 11 9.98528 11 7.5C11 5.01472 13.0147 3 15.5 3C17.9853 3 20 5.01472 20 7.5Z"
      stroke="#7D858F"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const DesignSvg = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      id="Vector"
      d="M7.87451 2.81228C7.03194 2.81228 6.25236 3.07664 5.61115 3.52661C5.56953 2.88202 5.42216 2.32293 5.15105 1.82797C6.00737 1.35408 6.97252 1.11183 7.95113 1.12517C8.92974 1.1385 9.88793 1.40695 10.731 1.90399C11.5741 2.40103 12.2729 3.10945 12.7584 3.95926C13.2439 4.80906 13.4992 5.77083 13.4992 6.74953H16.0314C16.5533 6.74953 17.0538 6.95679 17.423 7.32573C17.7922 7.69468 17.9997 8.19512 18 8.71703V14.9041C18.0001 15.1629 17.9493 15.4191 17.8504 15.6581C17.7514 15.8972 17.6063 16.1144 17.4234 16.2973C17.2405 16.4802 17.0233 16.6253 16.7842 16.7243C16.5452 16.8232 16.289 16.874 16.0302 16.8739H9.84313C9.32102 16.8739 8.82029 16.6665 8.45111 16.2973C8.08192 15.9281 7.87451 15.4274 7.87451 14.9053V12.3742C7.09199 12.3752 6.31793 12.2123 5.60215 11.8961C5.61677 11.5136 5.62465 11.112 5.62465 10.6868V10.617C5.62465 10.4292 5.62465 10.2132 5.62127 9.97921C6.28193 10.4407 7.06861 10.6878 7.87451 10.6868V8.71816C7.87451 7.63148 8.75645 6.74953 9.84313 6.74953H11.8118C11.8118 5.70531 11.3969 4.70385 10.6586 3.96547C9.92019 3.2271 8.91873 2.81228 7.87451 2.81228ZM13.2415 8.43693C12.9689 9.30074 12.4921 10.0861 11.8516 10.7267C11.2111 11.3672 10.4257 11.8439 9.5619 12.1166V14.9053C9.5619 15.0605 9.68789 15.1865 9.84313 15.1865H16.0302C16.1048 15.1865 16.1764 15.1569 16.2291 15.1041C16.2819 15.0514 16.3115 14.9799 16.3115 14.9053V8.71816C16.3115 8.64357 16.2819 8.57204 16.2291 8.5193C16.1764 8.46656 16.1048 8.43693 16.0302 8.43693H13.2415ZM11.4327 8.43693H9.84313C9.76855 8.43693 9.69701 8.46656 9.64427 8.5193C9.59153 8.57204 9.5619 8.64357 9.5619 8.71816V10.3077C10.3818 9.9174 11.0424 9.25682 11.4327 8.43693ZM2.90344 0.140571C2.99682 0.222243 3.06057 0.332493 3.08478 0.454159C3.10899 0.575825 3.0923 0.702083 3.03731 0.813279C3.02779 0.84619 3.02287 0.880262 3.02269 0.914523C3.02269 0.985393 3.04069 1.12038 3.21055 1.28912C3.29267 1.37124 3.35567 1.42974 3.42429 1.49386C3.48053 1.54561 3.54015 1.5996 3.61552 1.67385C3.76177 1.81334 3.91588 1.97758 4.05425 2.18344C4.3411 2.61429 4.49972 3.15313 4.49972 3.93721C4.49972 4.89677 4.14424 5.7146 3.58965 6.21632L3.66165 6.29956C3.97663 6.68654 4.15999 7.18825 4.27473 7.68322C4.49972 8.66191 4.49972 9.83859 4.49972 10.6587V10.6868C4.49972 13.822 4.07337 15.6005 3.60427 16.6174C3.36804 17.1293 3.11718 17.4555 2.90007 17.6602C2.8118 17.7449 2.71447 17.8196 2.60984 17.883C2.56193 17.9118 2.51191 17.937 2.46022 17.9583C2.46022 17.9583 2.3331 17.9988 2.24986 17.9988C2.16661 17.9988 2.0395 17.9583 2.0395 17.9583C1.98724 17.9382 1.93712 17.913 1.88988 17.883C1.78525 17.8196 1.68792 17.7449 1.59965 17.6602C1.38254 17.4544 1.13168 17.1293 0.895444 16.6174C0.426348 15.6005 0 13.822 0 10.6868V10.6587C0 9.83747 5.36408e-08 8.66191 0.224986 7.68322C0.339729 7.18825 0.523092 6.68654 0.838072 6.29956C0.860571 6.27144 0.88532 6.24331 0.910068 6.21632C0.355478 5.7146 0 4.89677 0 3.93721C0 3.57048 0.0978689 3.13288 0.23286 2.72903C0.367852 2.32406 0.55684 1.90559 0.775076 1.56811C1.03494 1.12938 1.40054 0.761532 1.68402 0.514048C1.83944 0.377365 2.00163 0.248585 2.16999 0.128197L2.21949 0.0944491C2.32264 0.0256896 2.44562 -0.00706577 2.5693 0.00127498C2.69299 0.00961574 2.81046 0.0585852 2.90344 0.140571Z"
      fill="#7D858F"
    />
  </svg>
);

const AdditionalDetailsSvg = () => (
  <svg
    width="17"
    height="22"
    viewBox="0 0 17 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Group 39952">
      <path
        id="Vector"
        d="M10.8182 14.6816H6.18183C5.56701 14.6816 4.97737 14.9258 4.54263 15.3606C4.10788 15.7953 3.86365 16.385 3.86365 16.9998V18.5452H5.4091V16.9998C5.4091 16.7948 5.49051 16.5983 5.63543 16.4534C5.78034 16.3085 5.97689 16.2271 6.18183 16.2271H10.8182C11.0231 16.2271 11.2197 16.3085 11.3646 16.4534C11.5095 16.5983 11.5909 16.7948 11.5909 16.9998V18.5452H13.1364V16.9998C13.1364 16.385 12.8921 15.7953 12.4574 15.3606C12.0227 14.9258 11.433 14.6816 10.8182 14.6816ZM8.50001 13.9089C9.11133 13.9089 9.70893 13.7276 10.2172 13.388C10.7255 13.0483 11.1217 12.5656 11.3556 12.0008C11.5896 11.436 11.6508 10.8145 11.5315 10.215C11.4123 9.61538 11.1179 9.06463 10.6856 8.63236C10.2533 8.20009 9.70259 7.90571 9.10302 7.78644C8.50344 7.66718 7.88196 7.72839 7.31717 7.96233C6.75238 8.19628 6.26965 8.59245 5.93001 9.10074C5.59038 9.60904 5.4091 10.2066 5.4091 10.818C5.4091 11.6377 5.73475 12.4239 6.31441 13.0036C6.89407 13.5832 7.68025 13.9089 8.50001 13.9089ZM8.50001 9.27251C8.80567 9.27251 9.10447 9.36315 9.35862 9.53296C9.61277 9.70278 9.81085 9.94415 9.92782 10.2265C10.0448 10.5089 10.0754 10.8197 10.0158 11.1195C9.95614 11.4193 9.80895 11.6946 9.59281 11.9108C9.37668 12.1269 9.1013 12.2741 8.80151 12.3337C8.50173 12.3934 8.19099 12.3627 7.90859 12.2458C7.6262 12.1288 7.38483 11.9307 7.21501 11.6766C7.0452 11.4224 6.95456 11.1236 6.95456 10.818C6.95456 10.4081 7.11738 10.015 7.40721 9.72516C7.69704 9.43533 8.09013 9.27251 8.50001 9.27251Z"
        fill="#7D858F"
      />
      <path
        id="Vector_2"
        d="M15.4545 2.31818H13.1364V1.54545C13.1364 1.13557 12.9735 0.742482 12.6837 0.452653C12.3939 0.162824 12.0008 0 11.5909 0H5.40909C4.99921 0 4.60612 0.162824 4.31629 0.452653C4.02646 0.742482 3.86364 1.13557 3.86364 1.54545V2.31818H1.54545C1.13557 2.31818 0.742482 2.48101 0.452653 2.77083C0.162824 3.06066 0 3.45376 0 3.86364V20.0909C0 20.5008 0.162824 20.8939 0.452653 21.1837C0.742482 21.4735 1.13557 21.6364 1.54545 21.6364H15.4545C15.8644 21.6364 16.2575 21.4735 16.5473 21.1837C16.8372 20.8939 17 20.5008 17 20.0909V3.86364C17 3.45376 16.8372 3.06066 16.5473 2.77083C16.2575 2.48101 15.8644 2.31818 15.4545 2.31818ZM5.40909 1.54545H11.5909V4.63636H5.40909V1.54545ZM15.4545 20.0909H1.54545V3.86364H3.86364V6.18182H13.1364V3.86364H15.4545V20.0909Z"
        fill="#7D858F"
      />
    </g>
  </svg>
);

const DevelopmentSvg = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Group 39953">
      <path
        id="Vector"
        d="M3.85714 1.28571V3.85714H1.28571V1.28571H3.85714ZM0 0V5.14286H5.14286V0H0ZM10.2857 3.21429V5.78571H7.71429V3.21429H10.2857ZM6.42857 1.92857V7.07143H11.5714V1.92857H6.42857ZM3.85714 9V11.5714H1.28571V9H3.85714ZM0 7.71429V12.8571H5.14286V7.71429H0Z"
        fill="#7D858F"
      />
      <path
        id="Vector_2"
        d="M12.8571 5.14307V9.00021H8.99997V12.8574H5.14282V18.0002H18V5.14307H12.8571ZM10.2857 10.2859H12.8571V12.8574H10.2857V10.2859ZM8.99997 16.7145H6.42854V14.1431H8.99997V16.7145ZM12.8571 16.7145H10.2857V14.1431H12.8571V16.7145ZM16.7143 16.7145H14.1428V14.1431H16.7143V16.7145ZM16.7143 12.8574H14.1428V10.2859H16.7143V12.8574ZM14.1428 9.00021V6.42878H16.7143V9.00021H14.1428Z"
        fill="#7D858F"
      />
    </g>
  </svg>
);

const UatSvg = () => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Group 39954">
      <path
        id="Vector"
        d="M13.6666 15.0721V15.7422L10.3333 19.0927H2.33325V3.68066H4.99992"
        stroke="#7D858F"
        strokeWidth="0.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_2"
        d="M11 3.68066H13.6667V4.35075"
        stroke="#7D858F"
        strokeWidth="0.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_3"
        d="M13.6667 15.7422H10.3334L10.3335 19.0926"
        stroke="#7D858F"
        strokeWidth="0.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_4"
        d="M6.33337 8.37061H9.66671"
        stroke="#7D858F"
        strokeWidth="0.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_5"
        d="M6.33337 9.71094H9.66671"
        stroke="#7D858F"
        strokeWidth="0.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_6"
        d="M6.33337 11.0513H9.66671"
        stroke="#7D858F"
        strokeWidth="0.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_7"
        d="M10.6667 12.3916H6.33337"
        stroke="#7D858F"
        strokeWidth="0.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_8"
        d="M6.33337 13.7314H12.3334"
        stroke="#7D858F"
        strokeWidth="0.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_9"
        d="M6.33337 15.0718H9.00004"
        stroke="#7D858F"
        strokeWidth="0.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_10"
        d="M6.33337 16.4121H9.00004"
        stroke="#7D858F"
        strokeWidth="0.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_11"
        d="M9.00004 17.7524H6.33337"
        stroke="#7D858F"
        strokeWidth="0.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_12"
        d="M15 15.072V19.7626C14.9995 19.9401 14.9291 20.1103 14.8042 20.2358C14.6793 20.3614 14.51 20.4321 14.3334 20.4327H1.66667C1.49002 20.4321 1.32076 20.3614 1.19585 20.2358C1.07093 20.1103 1.00053 19.9401 1 19.7626V3.01042C1.00053 2.83286 1.07093 2.66273 1.19585 2.53718C1.32076 2.41163 1.49002 2.34086 1.66667 2.34033H6.33334"
        stroke="#7D858F"
        strokeWidth="0.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_13"
        d="M9.6665 2.34033H14.3332C14.5098 2.34086 14.6791 2.41163 14.804 2.53718C14.9289 2.66273 14.9993 2.83286 14.9998 3.01042V4.35059"
        stroke="#7D858F"
        strokeWidth="0.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_14"
        d="M9.66655 2.34017C9.66655 1.98474 9.52608 1.64386 9.27603 1.39253C9.02598 1.1412 8.68684 1 8.33322 1H7.66655C7.31293 1 6.97379 1.1412 6.72374 1.39253C6.47369 1.64386 6.33321 1.98474 6.33321 2.34017H4.99988V3.68035C4.99988 3.85806 5.07012 4.0285 5.19514 4.15417C5.32016 4.27983 5.48973 4.35043 5.66655 4.35043H10.3332C10.51 4.35043 10.6796 4.27983 10.8046 4.15417C10.9296 4.0285 10.9999 3.85806 10.9999 3.68035V2.34017H9.66655Z"
        stroke="#7D858F"
        strokeWidth="0.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_15"
        d="M4.99996 16.4121H3.66663V17.7523H4.99996V16.4121Z"
        stroke="#7D858F"
        strokeWidth="0.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_16"
        d="M4.99996 13.7314H3.66663V15.0716H4.99996V13.7314Z"
        stroke="#7D858F"
        strokeWidth="0.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_17"
        d="M4.99996 11.0513H3.66663V12.3914H4.99996V11.0513Z"
        stroke="#7D858F"
        strokeWidth="0.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_18"
        d="M6.33337 7.03076H10.6667"
        stroke="#7D858F"
        strokeWidth="0.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_19"
        d="M12.3334 5.69092H6.33337"
        stroke="#7D858F"
        strokeWidth="0.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_20"
        d="M3.66663 9.04069L4.33329 9.71078L4.99996 8.37061"
        stroke="#7D858F"
        strokeWidth="0.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_21"
        d="M3.66663 6.361L4.33329 7.03109L4.99996 5.69092"
        stroke="#7D858F"
        strokeWidth="0.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_22"
        d="M15.7955 6.46772L15.6667 5.69092H14.3333L14.2045 6.46772C13.8794 6.54837 13.5684 6.67829 13.2822 6.85302L12.643 6.39451L11.7 7.34235L12.1567 7.98479C11.9828 8.27247 11.8536 8.58507 11.7733 8.91186L11 9.04135V10.3815L11.7728 10.511C11.8531 10.8378 11.9823 11.1504 12.1562 11.4381L11.7 12.0805L12.643 13.0284L13.2822 12.5694C13.5684 12.7441 13.8794 12.874 14.2045 12.9547L14.3333 13.732H15.6667L15.7955 12.9552C16.1206 12.8745 16.4316 12.7446 16.7178 12.5699L17.357 13.0289L18.3 12.0805L17.8433 11.4381C18.0172 11.1504 18.1464 10.8378 18.2267 10.511L19 10.3815V9.04135L18.2272 8.91186"
        stroke="#7D858F"
        strokeWidth="0.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_23"
        d="M12.9999 9.71094C12.9999 10.2441 13.2106 10.7554 13.5857 11.1324C13.9607 11.5094 14.4694 11.7212 14.9999 11.7212C15.5303 11.7212 16.039 11.5094 16.4141 11.1324C16.7892 10.7554 16.9999 10.2441 16.9999 9.71094"
        stroke="#7D858F"
        strokeWidth="0.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_24"
        d="M15.0334 8.48579L14.0905 7.53829L13.1477 8.48579L15.0334 10.3811L18.3332 7.06437L17.3904 6.1167L15.0334 8.48579Z"
        stroke="#7D858F"
        strokeWidth="0.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

const GoLiveSvg = () => (
  <svg
    width="20"
    height="15"
    viewBox="0 0 20 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Group 39955">
      <path
        id="Vector"
        d="M3.54942 1C3.54942 1 -2.18678 7.39303 3.54942 13.9488"
        stroke="#7D858F"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        id="Vector_2"
        d="M16.075 1C16.075 1 22.6564 7.39303 16.075 13.9488"
        stroke="#7D858F"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        id="Vector_3"
        d="M6.70531 4.2373C6.70531 4.2373 3.8379 7.43373 6.70531 10.7117"
        stroke="#7D858F"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        id="Vector_4"
        d="M13.3099 4.2373C13.3099 4.2373 16.539 7.43373 13.3099 10.7117"
        stroke="#7D858F"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        id="Vector_5"
        d="M11.0245 8.59812C11.5706 8.04989 11.5706 7.16104 11.0245 6.61282C10.4784 6.06459 9.59301 6.06459 9.04691 6.61282C8.50081 7.16104 8.50081 8.0499 9.04691 8.59812C9.59301 9.14635 10.4784 9.14635 11.0245 8.59812Z"
        fill="#7D858F"
      />
    </g>
  </svg>
);

export const PaymentSvg = () => (
  <svg
    width="24"
    height="20"
    viewBox="0 0 24 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      id="Vector"
      d="M18.0491 0.856536C18.2548 0.794326 18.4595 0.773954 18.6632 0.795422C18.8669 0.81689 19.0594 0.879853 19.2407 0.98431C19.4219 1.08877 19.5768 1.21851 19.7053 1.37354C19.8338 1.52858 19.9339 1.71301 20.0053 1.92685L23.1379 12.2816C23.2012 12.491 23.2233 12.699 23.2042 12.9056C23.1851 13.1122 23.125 13.307 23.0239 13.4899C22.9228 13.6729 22.7965 13.8288 22.6451 13.9577C22.4936 14.0866 22.3129 14.1863 22.103 14.2568L5.9509 19.1431C5.74526 19.2053 5.54057 19.2257 5.33682 19.2042C5.13307 19.1828 4.94058 19.1198 4.75934 19.0153C4.5781 18.9109 4.42322 18.7811 4.2947 18.6261C4.16617 18.4711 4.06617 18.2866 3.99468 18.0728L0.862154 7.71807C0.798813 7.50869 0.776699 7.30069 0.795814 7.09407C0.814928 6.88745 0.875034 6.69266 0.976131 6.50972C1.07723 6.32677 1.2035 6.17084 1.35495 6.04192C1.5064 5.913 1.6871 5.81331 1.89705 5.74287L18.0491 0.856536ZM2.26558 6.96108C2.17834 6.98747 2.11532 7.0377 2.07651 7.11177C2.0377 7.18584 2.03173 7.26729 2.0586 7.35612L2.70353 9.48797L19.4538 4.42066L18.8089 2.2888C18.782 2.19997 18.7319 2.13549 18.6586 2.09536C18.5852 2.05522 18.5049 2.04835 18.4177 2.07474L2.26558 6.96108ZM21.7344 13.0386C21.8217 13.0122 21.8847 12.9619 21.9235 12.8879C21.9623 12.8138 21.9683 12.7324 21.9414 12.6435L19.8224 5.63886L3.07207 10.7062L5.19112 17.7108C5.218 17.7997 5.26811 17.8642 5.34147 17.9043C5.41483 17.9444 5.49513 17.9513 5.58237 17.9249L21.7344 13.0386ZM16.1422 10.7413L18.5351 10.0174L18.9036 11.2356L16.5107 11.9595L16.1422 10.7413Z"
      fill="#7D858F"
    />
  </svg>
);

export const ProtectSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
  >
    <circle cx="14" cy="14" r="14" fill="#ECE9FF" />
    <path
      d="M12.7273 17.1818L10.1818 14.6364L11.0791 13.7391L12.7273 15.3809L16.9209 11.1873L17.8182 12.0909M14 7L8.27271 9.54545V13.3636C8.27271 16.8955 10.7163 20.1982 14 21C17.2836 20.1982 19.7273 16.8955 19.7273 13.3636V9.54545L14 7Z"
      fill="#6F5BF6"
    />
  </svg>
);

export const PaymentMethodSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="200"
    height="29"
    viewBox="0 0 200 29"
    fill="none"
  >
    <g opacity="0.6" clipPath="url(#clip0_1487_7269)">
      <path
        d="M95.1188 0H107.489C108.399 0 109.3 0.180472 110.141 0.531113C110.981 0.881753 111.745 1.39569 112.389 2.04359C113.032 2.69149 113.543 3.46066 113.891 4.30718C114.239 5.1537 114.418 6.061 114.418 6.97726V19.4326C114.418 21.2828 113.688 23.0573 112.389 24.3656C111.09 25.6739 109.327 26.4089 107.49 26.4089H95.1197C93.2819 26.4089 91.5193 25.6738 90.2198 24.3653C88.9203 23.0568 88.1902 21.2821 88.1902 19.4316V6.97635C88.1902 5.12611 88.9202 3.35165 90.2195 2.04333C91.5189 0.735006 93.2812 0 95.1188 0Z"
        fill="#D9DCE0"
      />
      <path
        d="M98.8962 13.2043C98.8955 12.2491 99.1122 11.3064 99.5297 10.4487C99.9471 9.59093 100.554 8.8409 101.304 8.25616C100.385 7.5382 99.284 7.09431 98.1266 6.97497C96.9691 6.85562 95.8016 7.06559 94.7568 7.58102C93.712 8.09645 92.8317 8.89666 92.216 9.89071C91.6003 10.8848 91.2739 12.0328 91.2739 13.2043C91.2739 14.3758 91.6003 15.5238 92.216 16.5179C92.8317 17.5119 93.712 18.3121 94.7568 18.8276C95.8016 19.343 96.9691 19.553 98.1266 19.4336C99.284 19.3143 100.385 18.8704 101.304 18.1524C100.554 17.5677 99.9471 16.8177 99.5297 15.9599C99.1122 15.1022 98.8955 14.1595 98.8962 13.2043Z"
        fill="#FF0015"
      />
      <path
        d="M105.115 6.94337C103.735 6.94131 102.394 7.40372 101.304 8.25714C102.054 8.84233 102.661 9.59246 103.078 10.4501C103.496 11.3077 103.713 12.2502 103.713 13.2053C103.713 14.1604 103.496 15.1028 103.078 15.9604C102.661 16.8181 102.054 17.5682 101.304 18.1534C102.086 18.7641 103.002 19.1781 103.975 19.3609C104.948 19.5437 105.95 19.4901 106.898 19.2045C107.846 18.9189 108.713 18.4096 109.426 17.7189C110.14 17.0282 110.679 16.176 111 15.2332C111.32 14.2904 111.413 13.2842 111.269 12.2982C111.126 11.3122 110.751 10.3749 110.175 9.56415C109.6 8.75342 108.841 8.09269 107.961 7.63687C107.08 7.18105 106.105 6.94329 105.115 6.94337Z"
        fill="#00A1E1"
      />
      <path
        d="M103.712 13.205C103.712 12.2497 103.496 11.307 103.078 10.4492C102.661 9.59143 102.054 8.84143 101.303 8.25684C100.554 8.84203 99.947 9.59215 99.5296 10.4498C99.1122 11.3074 98.8951 12.2499 98.8951 13.205C98.8951 14.1601 99.1122 15.1025 99.5296 15.9601C99.947 16.8178 100.554 17.5679 101.303 18.1531C102.054 17.5685 102.661 16.8185 103.078 15.9607C103.496 15.1029 103.712 14.1602 103.712 13.205Z"
        fill="#7874C3"
      />
      <path
        d="M111.028 16.2956H110.95V16.4783H110.912V16.2956H110.834V16.2627H111.028V16.2956Z"
        fill="#00A1E1"
      />
      <path
        d="M111.324 16.4801H111.285V16.2974L111.216 16.4564H111.176L111.106 16.2992V16.4774H111.067V16.2627H111.127L111.196 16.4189L111.265 16.2627H111.324V16.4801Z"
        fill="#00A1E1"
      />
      <path
        d="M137.717 5.98283e-08H150.087C151.924 5.98283e-08 153.687 0.735006 154.986 2.04333C156.285 3.35165 157.015 5.12611 157.015 6.97635V19.4326C157.015 21.2828 156.285 23.0573 154.986 24.3656C153.687 25.6739 151.924 26.4089 150.087 26.4089H137.717C135.879 26.4089 134.116 25.6738 132.817 24.3653C131.517 23.0568 130.787 21.2821 130.787 19.4316V6.97635C130.787 6.06013 130.966 5.15288 131.315 4.30641C131.663 3.45994 132.173 2.69083 132.817 2.043C133.46 1.39518 134.224 0.881322 135.065 0.530781C135.906 0.18024 136.807 -0.000119928 137.717 5.98283e-08Z"
        fill="#D9DCE0"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M143.331 10.0368C143.798 9.93452 144.266 9.83585 144.733 9.73535C144.733 10.1154 144.733 10.4955 144.733 10.8755C144.267 10.9852 143.797 11.0829 143.327 11.1789C143.327 10.7979 143.327 10.4169 143.327 10.0368H143.331Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M137.655 10.6811C138.109 10.5842 138.562 10.4901 139.016 10.3896C139.027 10.7971 139.022 11.2055 139.024 11.613C139.376 11.613 139.728 11.613 140.08 11.613C140.09 12.0141 140.08 12.4151 140.08 12.8153H139.021C139.021 13.4932 139.021 14.1711 139.021 14.849C139.021 15.0454 139.099 15.2629 139.285 15.3506C139.54 15.4657 139.829 15.4045 140.083 15.3222C140.083 15.7023 140.083 16.0833 140.083 16.4643C139.783 16.6159 139.441 16.647 139.111 16.6516C138.914 16.6589 138.717 16.6247 138.534 16.5512C138.351 16.4777 138.186 16.3665 138.048 16.2248C137.91 16.083 137.803 15.9138 137.734 15.728C137.665 15.5422 137.635 15.3439 137.647 15.1459C137.652 13.6576 137.647 12.1694 137.656 10.6811H137.655Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M134.428 11.8771C134.973 11.5007 135.671 11.4788 136.302 11.5683C136.573 11.6098 136.838 11.6805 137.093 11.7794C137.093 12.2207 137.093 12.6619 137.093 13.1032C136.652 12.8722 136.163 12.7489 135.665 12.7432C135.498 12.7432 135.264 12.7926 135.232 12.9918C135.19 13.1745 135.356 13.306 135.505 13.37C135.986 13.5838 136.535 13.6788 136.941 14.0388C137.433 14.4654 137.485 15.2456 137.193 15.802C136.95 16.2588 136.451 16.5183 135.958 16.6069C135.251 16.7203 134.526 16.6251 133.871 16.3328C133.871 15.8879 133.871 15.443 133.871 14.998C134.319 15.2458 134.814 15.397 135.323 15.4421C135.494 15.4624 135.667 15.4305 135.819 15.3507C135.858 15.3202 135.889 15.281 135.91 15.2363C135.931 15.1915 135.941 15.1424 135.939 15.093C135.937 15.0436 135.924 14.9953 135.901 14.9519C135.877 14.9086 135.844 14.8715 135.803 14.8436C135.531 14.6472 135.197 14.5787 134.896 14.448C134.501 14.2927 134.09 14.0589 133.917 13.6468C133.671 13.0347 133.876 12.2526 134.428 11.8799V11.8771Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M149.063 12.2719C148.739 11.8151 148.202 11.5044 147.639 11.519C147.239 11.5242 146.855 11.68 146.563 11.9558C146.539 11.8416 146.515 11.7274 146.49 11.6132C146.08 11.6132 145.674 11.6132 145.259 11.6132C145.259 13.8058 145.259 15.9985 145.259 18.1912C145.726 18.0943 146.193 17.992 146.66 17.8933C146.66 17.3622 146.66 16.8314 146.66 16.3009C146.938 16.5265 147.284 16.6508 147.641 16.6536C147.89 16.6568 148.138 16.6049 148.365 16.5015C148.592 16.3981 148.795 16.2457 148.957 16.0551C149.381 15.5636 149.536 14.8967 149.562 14.2599C149.596 13.5683 149.475 12.8392 149.063 12.2719ZM148.146 14.5203C148.083 14.8336 147.935 15.1598 147.648 15.3224C147.486 15.3988 147.305 15.4228 147.13 15.3912C146.954 15.3596 146.792 15.274 146.667 15.1461C146.662 14.4426 146.66 13.7391 146.659 13.0356C146.764 12.929 146.893 12.8504 147.036 12.8068C147.179 12.7633 147.33 12.7562 147.476 12.7862C147.597 12.8231 147.709 12.8868 147.804 12.9728C147.898 13.0588 147.972 13.1648 148.02 13.2832C148.19 13.6721 148.234 14.1048 148.146 14.5203Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M153.966 14.618C154.031 13.9255 153.976 13.1946 153.656 12.5669C153.55 12.3461 153.402 12.1485 153.219 11.9858C153.037 11.823 152.824 11.6982 152.594 11.6186C151.938 11.4094 151.168 11.5382 150.648 12.0051C150.128 12.4719 149.868 13.1864 149.831 13.8789C149.794 14.5714 149.91 15.3041 150.339 15.8614C150.692 16.2959 151.202 16.5716 151.756 16.6279C152.416 16.6992 153.109 16.6097 153.696 16.2853C153.696 15.9053 153.696 15.5252 153.696 15.1451C153.275 15.3548 152.811 15.4621 152.342 15.4585C152.069 15.4585 151.785 15.4211 151.562 15.2575C151.463 15.1797 151.382 15.081 151.325 14.9683C151.268 14.8556 151.236 14.7317 151.231 14.6052C152.144 14.618 153.055 14.6052 153.966 14.618ZM151.217 13.571C151.222 13.3289 151.279 13.0722 151.45 12.8931C151.564 12.7693 151.721 12.6927 151.888 12.6778C152.056 12.663 152.223 12.711 152.357 12.8127C152.585 12.9899 152.658 13.2933 152.665 13.5701C152.182 13.5655 151.699 13.5646 151.217 13.5664V13.571Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M142.316 11.603C142.536 11.5373 142.769 11.5373 142.989 11.603C142.994 12.0351 142.989 12.4682 142.989 12.9012C142.617 12.7943 142.166 12.872 141.923 13.1972C141.923 14.3137 141.923 15.4304 141.923 16.5474H140.524C140.524 14.9029 140.524 13.2584 140.524 11.6139C140.927 11.6139 141.33 11.6139 141.732 11.6139C141.761 11.751 141.79 11.888 141.817 12.0241C141.925 11.828 142.101 11.6787 142.312 11.6048L142.316 11.603Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M143.331 11.6133H144.733C144.733 13.2578 144.733 14.9041 144.733 16.5523C144.263 16.5523 143.794 16.5605 143.325 16.545C143.334 14.9014 143.328 13.2578 143.331 11.6133Z"
        fill="white"
      />
      <path
        d="M177.444 26.2888L182.406 4.75586C182.543 4.17925 182.814 3.64358 183.197 3.19274C183.579 2.74189 184.062 2.38871 184.607 2.16211H180.705C179.795 2.16163 178.894 2.34163 178.053 2.69182C177.212 3.04202 176.448 3.55556 175.804 4.20312C175.16 4.85068 174.649 5.61958 174.301 6.46591C173.952 7.31225 173.772 8.21945 173.772 9.13572V21.5938C173.775 22.9038 174.144 24.1864 174.839 25.2941C175.534 26.4018 176.525 27.2897 177.698 27.8557C177.413 27.3869 177.322 26.8244 177.444 26.2888Z"
        fill="#D4D7DA"
      />
      <path
        d="M187.085 26.2888L192.048 4.75586C192.308 3.62389 193.083 2.75139 194.068 2.26352C193.738 2.20507 193.404 2.17117 193.07 2.16211H184.605C184.061 2.3887 183.578 2.74189 183.195 3.19274C182.813 3.64358 182.542 4.17925 182.405 4.75586L177.444 26.2888C177.322 26.8244 177.413 27.3869 177.698 27.8557C178.632 28.3204 179.659 28.5651 180.701 28.571H188.039C187.663 28.3395 187.368 27.9945 187.196 27.5849C187.025 27.1754 186.986 26.722 187.085 26.2888Z"
        fill="#D9DCE0"
      />
      <path
        d="M195.546 2.64099C195.069 2.46028 194.573 2.33372 194.068 2.26367C193.083 2.75154 192.308 3.62404 192.048 4.75601L187.085 26.289C186.986 26.7224 187.024 27.1762 187.196 27.5861C187.367 27.9961 187.662 28.3413 188.039 28.573H193.071C194.909 28.5728 196.671 27.8375 197.971 26.5291C199.27 25.2206 200 23.4461 200 21.5957V9.13587C199.998 7.72658 199.571 6.35121 198.775 5.19154C197.98 4.03187 196.854 3.1425 195.546 2.64099Z"
        fill="#D4D7DA"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M188.677 18.3845C188.741 18.2986 188.741 18.1826 188.768 18.083H189.332C189.318 18.2239 189.294 18.3637 189.261 18.5014C189.235 18.5781 189.187 18.6455 189.124 18.6957C189.06 18.7459 188.984 18.7768 188.904 18.7847C188.73 18.802 188.556 18.7975 188.382 18.8102C188.391 18.9418 188.392 19.0734 188.403 19.2049C188.405 19.2211 188.41 19.2366 188.418 19.2508C188.426 19.2649 188.437 19.2773 188.449 19.2873C188.462 19.2972 188.477 19.3045 188.492 19.3087C188.508 19.3129 188.524 19.314 188.54 19.3118C188.698 19.3118 188.856 19.2926 189.014 19.2844C188.976 19.4671 188.929 19.6444 188.89 19.8253C188.694 19.8317 188.499 19.8253 188.303 19.8253C188.162 19.8284 188.021 19.8158 187.883 19.7878C187.837 19.7775 187.796 19.7514 187.767 19.7141C187.738 19.6768 187.723 19.6305 187.724 19.5832C187.701 19.0929 187.681 18.6022 187.664 18.1113H188.374C188.381 18.2073 188.383 18.3041 188.382 18.4009C188.48 18.4104 188.578 18.4036 188.673 18.3808L188.677 18.3845Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M184.387 17.5892C184.426 17.4201 184.465 17.2511 184.508 17.083C185.205 17.083 185.904 17.083 186.602 17.083C186.561 17.2511 186.521 17.4195 186.482 17.5882H185.646C185.612 17.7317 185.579 17.8751 185.545 18.0176H186.398C186.356 18.1921 186.313 18.3657 186.273 18.5411H185.421C185.366 18.7668 185.31 18.9915 185.261 19.2181C185.236 19.2784 185.315 19.2894 185.352 19.3022C185.558 19.3451 185.763 19.2775 185.969 19.2601C185.923 19.452 185.878 19.643 185.832 19.8348C185.491 19.8348 185.151 19.8348 184.81 19.8348C184.701 19.8248 184.572 19.8138 184.5 19.7206C184.466 19.6918 184.44 19.6552 184.424 19.6138C184.409 19.5725 184.403 19.5279 184.409 19.484C184.479 19.1706 184.559 18.8609 184.628 18.5475C184.471 18.5475 184.314 18.5475 184.156 18.5475C184.197 18.3712 184.24 18.1949 184.281 18.0176H184.758C184.791 17.8742 184.825 17.7326 184.859 17.5892H184.387Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M193.093 15.9023C193.365 15.9023 193.648 15.9023 193.925 15.9023C193.925 16.0184 193.932 16.1344 193.947 16.2495C194.016 16.3116 194.129 16.2824 194.211 16.2897C194.173 16.4633 194.13 16.636 194.085 16.8077C193.891 16.8077 193.697 16.8077 193.502 16.8077C193.437 16.8114 193.371 16.7994 193.31 16.7725C193.25 16.7457 193.197 16.7049 193.155 16.6533C193.12 16.595 193.104 16.5268 193.11 16.4587C193.103 16.276 193.101 16.0933 193.093 15.9042V15.9023Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M195.144 17.4636C195.186 17.2909 195.225 17.1182 195.265 16.9455H192.781C192.742 17.1173 192.698 17.2891 192.662 17.4617C192.959 17.4617 193.256 17.4617 193.552 17.4617C193.515 17.5988 193.487 17.7358 193.45 17.8756C193.149 17.8756 192.849 17.8756 192.549 17.8756C192.516 18.0291 192.478 18.1807 192.444 18.3324C192.708 18.3324 192.97 18.3324 193.233 18.3324C193.051 18.6202 192.87 18.9125 192.68 19.1985C192.569 19.3483 192.368 19.3291 192.204 19.3255C192.22 19.2506 192.238 19.1766 192.254 19.1026H192.042C192.247 18.2145 192.454 17.3274 192.659 16.4403H192.925C192.972 16.2576 193.016 16.0749 193.058 15.8921C192.656 15.8921 192.254 15.9077 191.854 15.9424C191.671 15.9668 191.499 16.0403 191.355 16.1553C191.376 16.0639 191.395 15.9725 191.415 15.8857H190.637C190.389 16.972 190.134 18.0556 189.883 19.14H189.726C189.687 19.3127 189.643 19.4854 189.604 19.659H191.147C191.134 19.7156 191.121 19.7723 191.11 19.8289C191.364 19.8289 191.618 19.8289 191.873 19.8289C191.887 19.7713 191.901 19.7147 191.916 19.6581H192.125C192.113 19.7147 192.101 19.7704 192.091 19.828C192.302 19.828 192.512 19.828 192.727 19.828C192.825 19.8239 192.922 19.7971 193.008 19.7496C193.095 19.702 193.17 19.6351 193.227 19.5539C193.364 19.3584 193.484 19.1528 193.622 18.9582C193.671 19.1519 193.703 19.3502 193.755 19.5429C193.796 19.6845 193.947 19.7439 194.072 19.7924C194.247 19.8128 194.423 19.8195 194.599 19.8125C194.643 19.6224 194.69 19.4315 194.732 19.2424C194.637 19.2479 194.543 19.2415 194.45 19.2232C194.407 19.214 194.409 19.161 194.397 19.1318C194.353 18.929 194.306 18.7271 194.263 18.5252C194.142 18.5252 194.02 18.5252 193.9 18.5252C193.948 18.4606 193.997 18.3967 194.047 18.3333H194.945C194.98 18.1798 195.016 18.0263 195.052 17.8765H194.219C194.252 17.7385 194.285 17.6024 194.318 17.4608L195.144 17.4636ZM191.283 19.1145H190.672C190.716 18.9162 190.763 18.7198 190.808 18.5224H191.419C191.378 18.7198 191.33 18.9171 191.283 19.1145ZM191.555 17.9587C191.324 17.9777 191.1 18.0479 190.898 18.1643C190.949 17.9313 191.004 17.7002 191.06 17.469C191.263 17.469 191.467 17.469 191.67 17.469C191.629 17.6329 191.589 17.7961 191.551 17.9587H191.555ZM191.794 16.9364C191.566 16.951 191.344 17.0132 191.141 17.1191C191.19 16.8944 191.247 16.6714 191.296 16.4467H191.907C191.866 16.6084 191.828 16.7729 191.789 16.9364H191.794Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M188.802 15.8969C188.599 15.896 188.396 15.9243 188.2 15.9809C188.065 16.0189 187.94 16.0838 187.831 16.1719L187.722 16.255C187.749 16.1335 187.776 16.012 187.804 15.8896C187.558 15.8896 187.313 15.8896 187.067 15.8896C186.796 17.0243 186.527 18.1602 186.258 19.2974C186.226 19.4059 186.211 19.5186 186.212 19.6317C186.238 19.6817 186.276 19.7244 186.322 19.7563C186.369 19.7881 186.422 19.8081 186.478 19.8145C186.643 19.8309 186.81 19.83 186.977 19.83H187.552C187.599 19.6336 187.643 19.4353 187.69 19.2389C187.492 19.2471 187.292 19.3074 187.096 19.269C187.041 19.196 187.081 19.1073 187.096 19.0288C187.186 18.6798 187.256 18.3253 187.351 17.9781C187.799 17.9882 188.246 17.9781 188.693 17.9781C188.908 17.9827 189.141 17.9169 189.274 17.7397C189.368 17.5931 189.435 17.4301 189.469 17.2591C189.577 16.8023 189.684 16.3455 189.793 15.8887C189.466 15.8969 189.134 15.9069 188.802 15.8969ZM188.641 17.5049C188.246 17.5112 187.851 17.4948 187.461 17.5131C187.474 17.4299 187.495 17.3495 187.513 17.2673H187.577C187.954 17.2673 188.331 17.2673 188.707 17.2673L188.641 17.5049ZM188.836 16.7484C188.549 16.7603 188.252 16.71 187.977 16.8087C187.86 16.8482 187.75 16.9028 187.647 16.9713L187.564 17.0389C187.616 16.8461 187.648 16.6479 187.71 16.4579C188.107 16.4734 188.506 16.4579 188.903 16.4652C188.879 16.5593 188.857 16.6534 188.835 16.7484H188.836Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M184.891 16.387C184.981 16.2281 185.054 16.059 185.136 15.8955C185.422 15.8955 185.71 15.8955 185.998 15.8955L185.864 16.1842H186.722C186.679 16.3587 186.64 16.5332 186.596 16.7068C186.205 16.7068 185.814 16.7068 185.423 16.7068C185.37 16.7713 185.304 16.8244 185.23 16.863C185.114 16.924 184.988 16.9654 184.859 16.9854C184.707 16.9946 184.556 16.9854 184.405 16.9854C184.445 16.8146 184.486 16.6447 184.527 16.4738C184.649 16.4665 184.818 16.5113 184.89 16.3825L184.891 16.387Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M182.737 13.167C183.057 13.1232 183.372 13.0702 183.694 13.0117C183.679 13.1181 183.657 13.2234 183.629 13.3269C183.53 13.739 183.434 14.1492 183.346 14.5649C183.335 14.6753 183.311 14.7841 183.276 14.8892C183.081 14.8892 182.887 14.8892 182.693 14.8892C182.578 14.8979 182.462 14.8979 182.347 14.8892C182.396 14.6663 182.498 14.4589 182.542 14.235C182.632 13.8833 182.683 13.5252 182.737 13.167Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M193.915 12.7166C193.849 12.712 193.845 12.7823 193.834 12.8298C193.79 12.7532 193.726 12.6895 193.65 12.6451C193.574 12.6008 193.487 12.5772 193.399 12.5768C193.13 12.6022 192.877 12.7115 192.673 12.8892C192.436 13.092 192.271 13.3662 192.201 13.6713C192.131 13.928 192.078 14.203 192.145 14.4661C192.165 14.5469 192.203 14.6224 192.254 14.6877C192.305 14.753 192.37 14.8067 192.443 14.8453C192.624 14.9421 192.83 14.9822 193.034 14.9604C193.174 14.9319 193.305 14.8666 193.412 14.7713C193.396 14.8247 193.39 14.8809 193.394 14.9366C193.684 14.9165 193.973 14.9202 194.263 14.9193C194.272 14.9213 194.281 14.9211 194.29 14.9188C194.299 14.9165 194.308 14.9122 194.315 14.906C194.322 14.8999 194.327 14.8922 194.331 14.8836C194.334 14.8749 194.336 14.8656 194.335 14.8562C194.45 14.1308 194.623 13.4155 194.796 12.7019C194.805 12.659 194.809 12.6151 194.814 12.5713C194.515 12.6252 194.215 12.6754 193.915 12.7166ZM193.649 13.8421C193.604 14.0047 193.583 14.1866 193.468 14.3172C193.425 14.359 193.374 14.3915 193.318 14.4127C193.262 14.434 193.202 14.4434 193.142 14.4405C193.095 14.4291 193.053 14.4011 193.025 14.3615C192.997 14.322 192.984 14.2735 192.988 14.2249C192.996 13.9991 193.037 13.7758 193.108 13.5616C193.162 13.3963 193.231 13.1962 193.412 13.1359C193.461 13.1185 193.514 13.1197 193.562 13.1392C193.609 13.1588 193.648 13.1953 193.671 13.2419C193.762 13.4301 193.696 13.6484 193.649 13.8421Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M195.225 12.6772C195.498 12.6416 195.77 12.5859 196.042 12.5283C196.074 12.6066 196.088 12.6914 196.081 12.7759C196.094 13.0765 196.117 13.3771 196.124 13.6786L196.107 13.7169C196.149 13.7096 196.156 13.6603 196.175 13.6256C196.234 13.496 196.299 13.3694 196.37 13.2464C196.46 13.0783 196.54 12.9002 196.619 12.7238C196.636 12.6617 196.71 12.6727 196.76 12.6608C197.008 12.6316 197.254 12.5795 197.499 12.532C197.536 12.5201 197.56 12.5758 197.53 12.6005C196.815 13.868 196.099 15.1352 195.381 16.402C195.329 16.5196 195.245 16.6198 195.139 16.6905C195.032 16.7613 194.908 16.7998 194.78 16.8013C194.598 16.8013 194.417 16.8132 194.235 16.8095C194.275 16.635 194.314 16.4605 194.352 16.286C194.441 16.292 194.53 16.2856 194.617 16.2668C194.708 16.1828 194.759 16.0585 194.833 15.9562C195.046 15.6364 195.215 15.2893 195.413 14.9594C195.433 14.9217 195.44 14.8781 195.431 14.8361C195.387 14.3793 195.331 13.9225 195.27 13.473C195.24 13.2391 195.218 13.0052 195.174 12.7741C195.16 12.733 195.167 12.669 195.225 12.6736L195.225 12.6772Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M186.266 13.1437C186.253 13.047 186.217 12.9548 186.163 12.8743C186.108 12.7937 186.035 12.7271 185.95 12.6796C185.689 12.5316 185.376 12.5353 185.086 12.5627C184.825 12.5938 184.579 12.7012 184.379 12.8715C184.152 13.0867 183.996 13.3666 183.931 13.6736C183.86 13.9033 183.842 14.1466 183.879 14.3844C183.907 14.5363 183.991 14.6718 184.115 14.7636C184.3 14.8787 184.514 14.9389 184.732 14.9372C185.141 14.9564 185.577 14.8339 185.86 14.5206C186.013 14.3395 186.123 14.1263 186.184 13.8966C186.263 13.6543 186.291 13.3977 186.266 13.1437ZM185.408 13.3822C185.39 13.5683 185.353 13.752 185.298 13.9304C185.249 14.0893 185.191 14.2629 185.048 14.3607C185.007 14.3923 184.956 14.4069 184.906 14.4015C184.855 14.396 184.808 14.3709 184.775 14.3314C184.705 14.2309 184.729 14.0976 184.741 13.9834C184.774 13.7729 184.828 13.5663 184.902 13.3667C184.951 13.247 185.027 13.1182 185.16 13.0825C185.192 13.0727 185.227 13.0709 185.26 13.0775C185.293 13.084 185.324 13.0986 185.351 13.12C185.401 13.1973 185.421 13.2907 185.408 13.3822Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M187.37 12.5657C187.162 12.6096 186.949 12.627 186.741 12.6681C186.661 13.2799 186.544 13.8861 186.39 14.4834C186.35 14.6184 186.32 14.7561 186.3 14.8955C186.551 14.8955 186.801 14.8808 187.053 14.8882C187.102 14.8836 187.193 14.9064 187.197 14.8315C187.298 14.3126 187.402 13.7936 187.52 13.2784C187.624 13.2354 187.737 13.177 187.85 13.2172C187.941 13.2583 187.935 13.3761 187.925 13.4602C187.853 13.9453 187.729 14.4204 187.622 14.8982C187.789 14.8982 187.955 14.8863 188.123 14.8872C188.236 14.8872 188.35 14.8936 188.464 14.8872C188.521 14.8872 188.524 14.8215 188.533 14.7813C188.606 14.3034 188.721 13.8329 188.821 13.3606C188.856 13.1779 188.9 12.9824 188.832 12.8015C188.796 12.7136 188.732 12.6403 188.651 12.5932C188.444 12.5018 188.209 12.5356 187.999 12.5932C187.87 12.6371 187.748 12.6985 187.636 12.7759C187.657 12.6937 187.68 12.6114 187.701 12.5283C187.589 12.5018 187.48 12.5502 187.37 12.5657Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M180.501 12.6176C180.394 12.6263 180.289 12.6443 180.185 12.6715C180.171 12.7239 180.162 12.7774 180.158 12.8314C180.073 13.5303 179.886 14.2119 179.733 14.898C179.989 14.8925 180.244 14.8834 180.5 14.8889C180.545 14.8825 180.622 14.9062 180.636 14.8441C180.743 14.3215 180.842 13.7962 180.964 13.2764C181.059 13.2275 181.164 13.2021 181.27 13.2023C181.308 13.2196 181.339 13.2492 181.357 13.2865C181.376 13.3237 181.381 13.3662 181.373 13.407C181.31 13.9122 181.17 14.4028 181.067 14.8989C181.347 14.8834 181.63 14.8907 181.91 14.8843C181.961 14.8843 181.962 14.8268 181.972 14.7929C182.039 14.38 182.127 13.9707 182.221 13.5623C182.27 13.2937 182.383 12.9922 182.241 12.7337C182.207 12.6804 182.162 12.6357 182.109 12.6027C182.055 12.5698 181.995 12.5496 181.933 12.5436C181.754 12.5244 181.573 12.5456 181.404 12.6058C181.288 12.6501 181.178 12.707 181.075 12.7757C181.098 12.7001 181.117 12.6232 181.131 12.5455L181.102 12.5107C180.901 12.5427 180.703 12.5921 180.501 12.6185V12.6176Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M183.231 12.3235C183.368 12.2892 183.512 12.2975 183.644 12.3473C183.682 12.3609 183.716 12.3835 183.744 12.4132C183.771 12.443 183.791 12.479 183.802 12.5181C183.81 12.5692 183.804 12.6214 183.785 12.6695C183.767 12.7176 183.736 12.7599 183.696 12.7922C183.534 12.933 183.323 13.0045 183.109 12.9914C183.052 12.9907 182.995 12.9782 182.943 12.9544C182.89 12.9307 182.843 12.8963 182.805 12.8534C182.778 12.8136 182.764 12.7663 182.765 12.7181C182.766 12.6699 182.782 12.6233 182.811 12.5848C182.914 12.4494 183.064 12.3575 183.231 12.3272V12.3235Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M176.337 13.2533C176.513 12.4713 176.688 11.6889 176.862 10.9062C177.233 10.9337 177.606 10.9117 177.977 10.9181C177.784 11.5942 177.622 12.2785 177.449 12.9591C177.387 13.183 177.363 13.4159 177.323 13.6416C177.288 13.8463 177.36 14.0984 177.558 14.1898C177.691 14.2423 177.836 14.2554 177.976 14.2276C178.116 14.1997 178.245 14.1321 178.348 14.0326C178.554 13.8316 178.62 13.5365 178.683 13.267C178.857 12.4813 179.023 11.6947 179.192 10.9081C179.506 10.9364 179.821 10.9172 180.136 10.9218C179.934 11.6527 179.759 12.3836 179.574 13.1208C179.484 13.4781 179.404 13.8472 179.212 14.166C179.047 14.4319 178.8 14.6358 178.509 14.7462C178.11 14.8911 177.684 14.9439 177.263 14.9006C176.99 14.8892 176.726 14.8039 176.499 14.6539C176.422 14.5937 176.359 14.5181 176.313 14.4319C176.267 14.3457 176.239 14.2508 176.232 14.1532C176.224 14.01 176.234 13.8663 176.262 13.7257C176.277 13.5679 176.303 13.4114 176.338 13.257L176.337 13.2533Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M192.597 11.2181C192.449 11.0354 192.208 10.9577 191.982 10.9294C191.664 10.8976 191.344 10.8899 191.024 10.9065C190.661 10.9011 190.298 10.9166 189.935 10.8965C189.788 11.6219 189.633 12.3473 189.454 13.0663C189.305 13.6754 189.158 14.2869 189.013 14.9009C189.342 14.8926 189.672 14.8871 190.003 14.9009C190.099 14.4495 190.18 13.9955 190.303 13.5505C190.321 13.5165 190.344 13.4856 190.372 13.4592C190.589 13.4592 190.806 13.4592 191.022 13.4427C191.385 13.4171 191.756 13.3294 192.052 13.1093C192.246 12.9594 192.407 12.7708 192.525 12.5555C192.643 12.3401 192.716 12.1025 192.738 11.8576C192.766 11.6383 192.743 11.3944 192.597 11.2181ZM191.209 12.7548C190.976 12.8525 190.718 12.837 190.47 12.8379C190.561 12.3866 190.685 11.9417 190.766 11.4876C190.99 11.5113 191.214 11.5251 191.437 11.5525C191.52 11.5827 191.592 11.6391 191.641 11.7133C191.69 11.7874 191.714 11.8755 191.709 11.9645C191.708 12.1302 191.661 12.2922 191.572 12.432C191.484 12.5717 191.358 12.6836 191.209 12.7548Z"
        fill="white"
      />
      <path
        d="M6.92862 0.357422H19.2996C20.2096 0.357422 21.1107 0.537894 21.9514 0.888534C22.7922 1.23917 23.5561 1.75312 24.1995 2.40102C24.843 3.04891 25.3534 3.81808 25.7017 4.6646C26.0499 5.51112 26.2291 6.41842 26.2291 7.33469V19.79C26.2295 20.7064 26.0505 21.614 25.7024 22.4608C25.3543 23.3075 24.8439 24.077 24.2004 24.7251C23.5569 25.3732 22.7929 25.8873 21.952 26.238C21.1111 26.5887 20.2098 26.7692 19.2996 26.7691H6.92953C6.0193 26.7691 5.11799 26.5885 4.27709 26.2377C3.43618 25.8869 2.67215 25.3727 2.02865 24.7245C1.38515 24.0763 0.874779 23.3068 0.526698 22.46C0.178617 21.6131 -0.000357025 20.7056 5.347e-07 19.7891V7.33469C-0.000118632 6.41846 0.179008 5.51119 0.52715 4.66467C0.875293 3.81816 1.38563 3.04898 2.02903 2.40107C2.67242 1.75316 3.43627 1.2392 4.27694 0.888552C5.11762 0.537901 6.01867 0.357422 6.92862 0.357422Z"
        fill="#D9DCE0"
      />
      <path
        d="M2.33826 10.4157L2.38362 10.1745H5.28719C5.4529 10.1731 5.61601 10.216 5.75992 10.2987C5.86127 10.3555 5.94894 10.434 6.0167 10.5288C6.08445 10.6235 6.13062 10.7321 6.1519 10.8469L6.87779 14.791L8.70431 10.1699H10.5626L7.69714 16.9654H5.8679L4.44606 11.4207C4.44606 11.4207 4.39071 10.73 2.33826 10.4157Z"
        fill="white"
      />
      <path
        d="M13.0396 10.1699H11.2838L9.83569 16.9654H11.5914L13.0396 10.1699Z"
        fill="white"
      />
      <path
        d="M18.0629 10.3751L17.7399 11.8113C17.3101 11.5762 16.828 11.4551 16.3389 11.4595C15.5032 11.4595 15.2964 11.898 15.2964 12.0451C15.2964 12.1922 15.3953 12.4572 16.1021 12.8217C16.8089 13.1862 17.7308 13.5901 17.7308 14.7403C17.7308 15.8905 16.9142 17.0664 14.7619 17.0664C14.7619 17.0664 13.5334 17.0581 12.7703 16.7238L13.0897 15.2181C13.6 15.4998 14.171 15.6516 14.7529 15.6603C15.6838 15.6603 15.9125 15.2528 15.9125 15.0007C15.9125 14.7485 15.7655 14.4717 15.0205 14.1501C14.2756 13.8285 13.478 13.2136 13.478 12.2936C13.478 11.3736 14.2828 10.0498 16.417 10.0498C16.417 10.0498 17.4423 10.0836 18.0629 10.3751Z"
        fill="white"
      />
      <path
        d="M22.48 10.1846H21.0019C20.8427 10.1844 20.687 10.2317 20.5544 10.3205C20.4219 10.4092 20.3184 10.5355 20.2569 10.6834L17.6492 16.959H19.4748L19.8377 15.9467H22.0744L22.2749 16.959H23.8909L22.48 10.1846ZM20.325 14.5699L21.2578 12.0118L21.7922 14.5699H20.325Z"
        fill="white"
      />
      <path
        d="M53.8974 0.956055H66.2684C67.1784 0.956055 68.0795 1.13653 68.9202 1.48717C69.761 1.83781 70.5249 2.35175 71.1683 2.99965C71.8118 3.64755 72.3222 4.41672 72.6705 5.26324C73.0187 6.10976 73.1979 7.01705 73.1979 7.93332V20.3886C73.1979 22.2389 72.468 24.0133 71.1686 25.3216C69.8692 26.63 68.1069 27.365 66.2693 27.365H53.8974C52.0596 27.365 50.297 26.6299 48.9975 25.3214C47.698 24.0129 46.9679 22.2382 46.9679 20.3877V7.93332C46.9678 7.01702 47.1469 6.10967 47.4951 5.26309C47.8433 4.41652 48.3537 3.6473 48.9972 2.99938C49.6407 2.35146 50.4047 1.83752 51.2455 1.48692C52.0862 1.13633 52.9874 0.955935 53.8974 0.956055Z"
        fill="#D9DCE0"
      />
      <path
        d="M57.6755 14.1613C57.6748 13.2061 57.8914 12.2634 58.3089 11.4057C58.7263 10.5479 59.3335 9.79788 60.0837 9.21319C59.1643 8.49523 58.0633 8.05134 56.9059 7.932C55.7484 7.81265 54.5809 8.02262 53.5361 8.53805C52.4913 9.05348 51.611 9.85369 50.9953 10.8477C50.3796 11.8418 50.0532 12.9898 50.0532 14.1613C50.0532 15.3328 50.3796 16.4809 50.9953 17.4749C51.611 18.469 52.4913 19.2692 53.5361 19.7846C54.5809 20.3 55.7484 20.51 56.9059 20.3906C58.0633 20.2713 59.1643 19.8274 60.0837 19.1095C59.3333 18.5249 58.7261 17.7749 58.3086 16.9171C57.8911 16.0593 57.6746 15.1166 57.6755 14.1613Z"
        fill="#FF0015"
      />
      <path
        d="M63.8947 7.89942C62.5145 7.89703 61.1732 8.35913 60.0837 9.21229C60.8334 9.79748 61.4402 10.5476 61.8576 11.4052C62.275 12.2629 62.492 13.2053 62.492 14.1604C62.492 15.1155 62.275 16.0579 61.8576 16.9156C61.4402 17.7732 60.8334 18.5234 60.0837 19.1085C60.8657 19.719 61.781 20.1327 62.7537 20.3153C63.7264 20.4979 64.7283 20.4442 65.6762 20.1586C66.6241 19.873 67.4906 19.3638 68.2038 18.6733C68.917 17.9827 69.4562 17.1307 69.7766 16.1882C70.0971 15.2456 70.1895 14.2397 70.0463 13.2539C69.903 12.2682 69.5282 11.3311 68.953 10.5205C68.3778 9.7099 67.6188 9.04923 66.739 8.59336C65.8592 8.13749 64.8841 7.89959 63.8947 7.89942Z"
        fill="#FF9F00"
      />
      <path
        d="M62.4919 14.161C62.4925 13.2058 62.2757 12.2632 61.8583 11.4055C61.4409 10.5478 60.8338 9.79772 60.0838 9.21289C59.3341 9.79808 58.7274 10.5482 58.31 11.4058C57.8925 12.2635 57.6755 13.2059 57.6755 14.161C57.6755 15.1161 57.8925 16.0585 58.31 16.9162C58.7274 17.7738 59.3341 18.524 60.0838 19.1091C60.834 18.5245 61.4411 17.7744 61.8586 16.9167C62.276 16.0589 62.4927 15.1162 62.4919 14.161Z"
        fill="#FF6000"
      />
      <path
        d="M69.8072 17.2506H69.73V17.4333H69.691V17.2506H69.6139V17.2168H69.8072V17.2506Z"
        fill="#FF9F00"
      />
      <path
        d="M70.1029 17.4359H70.0648V17.2532L69.9949 17.4112H69.9577L69.8878 17.255V17.4331H69.8497V17.2139H69.9087L69.9777 17.3701L70.0475 17.2139H70.1065L70.1029 17.4359Z"
        fill="#FF9F00"
      />
    </g>
    <defs>
      <clipPath id="clip0_1487_7269">
        <rect width="200" height="28.5714" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const AndroidSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="55"
    height="30"
    viewBox="0 0 55 30"
    fill="none"
  >
    <g clipPath="url(#clip0_1648_6178)">
      <path
        d="M40.6524 9.03713L45.185 1.34929C45.3061 1.14283 45.339 0.897944 45.2766 0.66785C45.2143 0.437755 45.0617 0.241045 44.8521 0.120463C44.7483 0.0608379 44.6335 0.0219762 44.5143 0.00613253C44.3951 -0.00971117 44.2739 -0.00222147 44.1577 0.0281671C44.0414 0.0585557 43.9325 0.111238 43.8373 0.183159C43.742 0.255079 43.6623 0.344805 43.6027 0.447132L39.0104 8.23158C35.5064 6.67052 31.563 5.79338 27.3214 5.79338C23.0799 5.79338 19.1364 6.67052 15.6324 8.23366L11.0402 0.449217C10.9796 0.347127 10.899 0.257722 10.8031 0.186107C10.7073 0.114493 10.5979 0.06207 10.4813 0.0318328C10.3647 0.00159562 10.2432 -0.00586399 10.1237 0.00987987C10.0042 0.0256237 9.889 0.0642627 9.78473 0.123591C9.68046 0.182919 9.58914 0.261774 9.516 0.355654C9.44285 0.449534 9.38931 0.556601 9.35843 0.67074C9.32755 0.78488 9.31993 0.903858 9.33601 1.02088C9.35209 1.1379 9.39155 1.25068 9.45215 1.35277L13.9848 9.03713C6.16892 13.1844 0.874581 20.93 0 29.9981H54.6429C53.769 20.93 48.4746 13.1844 40.6524 9.03713ZM14.7763 22.4855C14.3232 22.4856 13.8802 22.3541 13.5033 22.1077C13.1265 21.8613 12.8328 21.5111 12.6593 21.1012C12.4858 20.6913 12.4404 20.2403 12.5288 19.8052C12.6171 19.37 12.8353 18.9703 13.1557 18.6566C13.4762 18.3429 13.8844 18.1292 14.3289 18.0427C14.7733 17.9562 15.234 18.0007 15.6526 18.1705C16.0712 18.3404 16.429 18.628 16.6806 18.9969C16.9323 19.3659 17.0665 19.7996 17.0664 20.2433C17.0662 20.8379 16.8249 21.4081 16.3954 21.8285C15.966 22.249 15.3836 22.4853 14.7763 22.4855ZM39.8609 22.4855C39.4077 22.4856 38.9647 22.3541 38.5879 22.1077C38.2111 21.8613 37.9173 21.5111 37.7439 21.1012C37.5704 20.6913 37.525 20.2403 37.6133 19.8052C37.7017 19.37 37.9199 18.9703 38.2403 18.6566C38.5607 18.3429 38.969 18.1292 39.4134 18.0427C39.8579 17.9562 40.3185 18.0007 40.7371 18.1705C41.1558 18.3404 41.5135 18.628 41.7652 18.9969C42.0169 19.3659 42.1511 19.7996 42.151 20.2433C42.1508 20.8379 41.9094 21.4081 41.48 21.8285C41.0506 22.249 40.4682 22.4853 39.8609 22.4855Z"
        fill="#6F5BF5"
      />
    </g>
    <defs>
      <clipPath id="clip0_1648_6178">
        <rect width="54.6429" height="30" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const IosSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="29"
    height="35"
    viewBox="0 0 29 35"
    fill="none"
  >
    <g clipPath="url(#clip0_1688_5450)">
      <path
        d="M24.5175 18.395C24.5173 17.0789 24.8355 15.7828 25.4444 14.6198C26.0532 13.4568 26.9342 12.4623 28.0104 11.723C27.046 10.5275 25.8302 9.5645 24.4516 8.90424C23.0729 8.24399 21.5661 7.90306 20.0407 7.90627C19.0703 7.90627 18.1321 8.21851 17.2419 8.55217C15.8871 9.06169 14.3963 9.06169 13.0415 8.55217C12.1501 8.214 11.212 7.90627 10.2415 7.90627C4.58484 7.90289 0 12.4985 0 18.1662C0 23.8338 4.58484 35 10.2415 35C11.378 35 12.4699 34.4601 13.4938 34.1174C14.5638 33.7589 15.7195 33.7589 16.7896 34.1174C17.8113 34.4556 18.9065 35 20.0407 35C23.6975 35 26.9063 30.3345 28.718 25.5043C27.448 24.8141 26.3867 23.7885 25.6471 22.5367C24.9074 21.2848 24.5171 19.8535 24.5175 18.395Z"
        fill="#6F5BF5"
      />
      <path
        d="M19.5694 5.24623C18.1209 6.91901 16.2514 7.83882 14.6759 7.82867C14.4531 6.25057 15.116 4.25428 16.57 2.58149C18.024 0.908706 19.8847 -0.014482 21.4601 0.000171814C21.6807 1.57827 21.0189 3.57457 19.5694 5.24623Z"
        fill="#6F5BF5"
      />
    </g>
    <defs>
      <clipPath id="clip0_1688_5450">
        <rect width="28.718" height="35" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const GooglePlaySvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="150"
    height="50"
    viewBox="0 0 150 50"
    fill="none"
  >
    <g clipPath="url(#clip0_1690_6372)">
      <path
        d="M141.118 0H8.51715C3.81326 0 0 3.84001 0 8.5769V41.4231C0 46.16 3.81326 50 8.51715 50H141.118C145.822 50 149.635 46.16 149.635 41.4231V8.5769C149.635 3.84001 145.822 0 141.118 0Z"
        fill="black"
      />
      <path
        d="M25.6199 24.9997L11.8323 38.6127C11.6082 38.4334 11.4276 38.2051 11.3039 37.9451C11.1803 37.6851 11.117 37.4002 11.1187 37.1119V12.8875C11.1168 12.5992 11.1801 12.3143 11.3037 12.0542C11.4273 11.7942 11.6081 11.566 11.8323 11.3867L25.6199 24.9997Z"
        fill="#01D5FD"
      />
      <path
        d="M30.2081 20.4686L25.6198 25.0004L11.8323 11.3874C12.1301 11.1449 12.4936 10.9985 12.8754 10.9672C13.2571 10.936 13.6394 11.0214 13.9722 11.2124L30.2081 20.4686Z"
        fill="#01F476"
      />
      <path
        d="M30.2081 29.534L13.9722 38.7869C13.6396 38.9783 13.2573 39.0641 12.8755 39.033C12.4937 39.002 12.1301 38.8556 11.8323 38.613L25.6198 25L30.2081 29.534Z"
        fill="#F83448"
      />
      <path
        d="M35.2222 26.675L30.2081 29.5344L25.6199 25.0025L30.2081 20.4707L35.2222 23.3268C35.516 23.4948 35.7604 23.7382 35.9304 24.0323C36.1004 24.3264 36.19 24.6606 36.19 25.0009C36.19 25.3412 36.1004 25.6754 35.9304 25.9695C35.7604 26.2636 35.516 26.507 35.2222 26.675Z"
        fill="#FFCB03"
      />
      <path
        d="M63.7347 26.9609C62.5105 26.9609 61.4037 27.405 60.6161 28.2123C59.7797 29.0677 59.3387 30.272 59.3387 31.694C59.3387 34.3959 61.0876 36.2828 63.5913 36.2828C64.7003 36.2985 65.7746 35.894 66.6013 35.1495C67.5192 34.3007 68.0047 33.0559 68.0047 31.5496C68.0047 30.2141 67.5974 29.0677 66.8251 28.2364C66.0527 27.405 64.9828 26.9609 63.7347 26.9609ZM63.6989 28.3501C65.414 28.3501 66.1972 30.0369 66.1972 31.6033C66.1972 33.5098 65.1327 34.8936 63.6652 34.8936C62.1977 34.8936 61.1321 33.5251 61.1321 31.6393C61.1299 30.0018 61.924 28.3501 63.6989 28.3501Z"
        fill="white"
      />
      <path
        d="M73.5629 26.9609C72.3398 26.9609 71.2318 27.405 70.4443 28.2123C69.609 29.0677 69.168 30.272 69.168 31.694C69.168 34.3959 70.9157 36.2828 73.4206 36.2828C74.5292 36.2986 75.6032 35.8941 76.4294 35.1495C77.3484 34.3007 77.8339 33.0559 77.8339 31.5496C77.8339 30.2141 77.4255 29.0677 76.6543 28.2364C75.8831 27.405 74.8109 26.9609 73.5629 26.9609ZM73.527 28.3501C75.2433 28.3501 76.0254 30.0369 76.0254 31.6032C76.0254 33.5098 74.9608 34.8936 73.4923 34.8936C72.0237 34.8936 70.9603 33.5251 70.9603 31.6393C70.9592 30.0018 71.7532 28.3501 73.527 28.3501Z"
        fill="white"
      />
      <path
        d="M85.6537 28.2976C85.3094 27.7704 84.5295 26.9609 82.999 26.9609C82.4771 26.9622 81.9612 27.0731 81.4843 27.2865C81.0073 27.4999 80.5798 27.8111 80.2291 28.2003C79.4231 29.0754 78.9962 30.2786 78.9962 31.694C78.9962 32.8973 79.3742 33.9911 80.0596 34.7918C80.3952 35.1888 80.8129 35.507 81.2835 35.7241C81.7542 35.9412 82.2663 36.052 82.7839 36.0487C83.9179 36.0487 84.8847 35.5838 85.4778 34.7645V35.4624C85.4778 37.8984 84.0124 38.4092 82.7839 38.4092C81.9085 38.42 81.0471 38.1876 80.2943 37.7376L80.1856 37.6698L79.7294 39.0721L79.7913 39.1147C80.4691 39.5698 81.5956 39.852 82.7242 39.852C83.6735 39.852 85.0053 39.666 85.9416 38.7811C86.8182 37.9924 87.2103 36.74 87.2103 34.7229V29.6562C87.2103 28.6094 87.244 27.9279 87.2809 27.2639L87.2874 27.1545H85.7156L85.6537 28.2976ZM83.2488 34.642C81.4326 34.642 80.7874 33.0012 80.7874 31.6043C80.7874 29.6912 81.7846 28.4048 83.2673 28.4048C84.4524 28.4048 85.1323 29.2351 85.3757 30.0139C85.4408 30.2374 85.4694 30.4702 85.4604 30.703V32.2683C85.4624 32.545 85.4217 32.8203 85.3398 33.0843C85.0215 34.0305 84.2014 34.6409 83.2488 34.6409V34.642Z"
        fill="white"
      />
      <path d="M91.4054 23.084H89.6316V36.0844H91.4054V23.084Z" fill="white" />
      <path
        d="M97.3927 26.9609C94.9421 26.9609 93.2302 28.9364 93.2302 31.7662C93.2302 33.0985 93.63 34.2241 94.3871 35.0215C95.1442 35.819 96.2673 36.2642 97.5904 36.2642C99.0025 36.2642 99.9616 35.9655 100.513 35.7172L100.587 35.6833L100.273 34.3466L100.165 34.3926C99.6216 34.6223 98.9699 34.8356 97.8044 34.8356C96.0664 34.8356 95.0019 33.78 94.9345 32.0058H101.009L101.027 31.8428C101.056 31.6186 101.071 31.3928 101.073 31.1668C101.073 30.6943 101 29.4834 100.327 28.4551C99.6846 27.4783 98.6701 26.9609 97.3927 26.9609ZM97.2678 28.2954C97.863 28.2954 98.3453 28.4803 98.6983 28.8424C99.2686 29.4265 99.3501 30.3016 99.3501 30.6746H94.9639C95.1029 29.7415 95.7242 28.2954 97.2678 28.2954Z"
        fill="white"
      />
      <path
        d="M115.862 24.6775C115.102 23.9906 113.944 23.6427 112.413 23.6427C111.406 23.6384 110.401 23.7175 109.406 23.879L109.324 23.8921V36.0842H111.079V31.2406C111.461 31.3053 111.847 31.3331 112.234 31.3238C113.837 31.3238 115.173 30.8392 115.992 29.9597C116.629 29.3034 116.951 28.4032 116.951 27.294C116.951 26.2188 116.565 25.2901 115.862 24.6775ZM112.27 29.8613C111.869 29.8709 111.468 29.836 111.075 29.7574V25.1905C111.527 25.1104 111.986 25.0738 112.445 25.0812C114.216 25.0812 115.192 25.8917 115.192 27.3618C115.196 28.9534 114.129 29.8613 112.27 29.8613Z"
        fill="white"
      />
      <path d="M120.479 23.084H118.706V36.0844H120.479V23.084Z" fill="white" />
      <path
        d="M129.216 33.894V30.6278C129.216 28.9542 128.627 26.959 125.823 26.959C124.747 26.959 123.69 27.2467 122.922 27.7498L122.857 27.7925L123.282 29.0318L123.391 28.9629C124.052 28.5521 124.813 28.3332 125.59 28.3307C126.831 28.3307 127.461 28.9771 127.461 30.2504V30.3313C125.427 30.3313 123.907 30.7842 123.057 31.6352C122.522 32.1712 122.25 32.8581 122.25 33.6763C122.243 34.3424 122.492 34.9854 122.944 35.4713C123.446 36.0019 124.156 36.2819 124.999 36.2819C126.054 36.2819 127.022 35.8356 127.626 35.0787L127.734 36.0817H129.374L129.352 35.9636C129.247 35.279 129.201 34.5865 129.216 33.894ZM125.414 34.9113C124.744 34.9113 124.027 34.5405 124.027 33.4969C124.02 33.2926 124.055 33.089 124.13 32.8989C124.205 32.7088 124.318 32.5363 124.462 32.3921C124.975 31.8857 125.944 31.6265 127.342 31.6265H127.499V33.043C127.495 33.204 127.466 33.3634 127.414 33.5155C127.27 33.9321 126.999 34.2918 126.639 34.5427C126.279 34.7936 125.849 34.9227 125.411 34.9113H125.414Z"
        fill="white"
      />
      <path
        d="M136.781 27.1595L135.043 32.3477C134.9 32.7633 134.772 33.202 134.659 33.5892C134.628 33.6986 134.596 33.808 134.566 33.9086C134.432 33.447 134.255 32.8869 134.082 32.3772L132.161 27.1562H130.227L133.486 35.3306C133.539 35.4516 133.573 35.5799 133.588 35.7113C133.566 35.8297 133.527 35.9441 133.471 36.0504C133.174 36.7206 132.728 37.3128 132.167 37.7808C131.771 38.1168 131.314 38.3737 130.823 38.5378L130.73 38.5673L131.177 40.0801L131.264 40.0648C131.5 40.021 132.342 39.8176 133.245 39.0147C134.277 38.1145 135.033 36.7253 136.244 33.5115L138.659 27.1562L136.781 27.1595Z"
        fill="white"
      />
      <path
        d="M58.0102 28.6445H51.017V30.4789H56.4048C56.2055 31.6683 55.6238 32.7588 54.7491 33.5827C53.8745 34.4067 52.7553 34.9186 51.5636 35.0397C50.3719 35.1607 49.1737 34.8842 48.1533 34.2528C47.1328 33.6213 46.3466 32.6697 45.9155 31.5444C45.4843 30.4191 45.4322 29.1824 45.7671 28.0243C46.1019 26.8663 46.8052 25.8511 47.7688 25.1348C48.7325 24.4184 49.9031 24.0407 51.1007 24.0596C52.2983 24.0785 53.4565 24.493 54.3974 25.2394L55.6922 23.9366C54.4214 22.8647 52.8256 22.2614 51.1683 22.2262C49.511 22.1911 47.8914 22.7262 46.5769 23.7432C45.2624 24.7602 44.3317 26.1983 43.9385 27.82C43.5453 29.4416 43.7131 31.1498 44.4142 32.6624C45.1153 34.1751 46.3077 35.4017 47.7946 36.1396C49.2815 36.8776 50.9738 37.0828 52.5922 36.7213C54.2105 36.3599 55.658 35.4534 56.6956 34.1516C57.7332 32.8497 58.2989 31.2305 58.2991 29.5612C58.299 29.2548 58.2801 28.9486 58.2427 28.6445H58.0102Z"
        fill="white"
      />
      <path
        d="M54.5538 14.5499H57.7376V13.6683H54.5538V11.0616H57.9201V10.168H53.4958V18.4167H58.1026V17.5241H54.5538V14.5499Z"
        fill="white"
      />
      <path
        d="M58.7347 11.0737H61.2255V18.4167H62.2954V11.0737H64.7992V10.168H58.7347V11.0737Z"
        fill="white"
      />
      <path d="M69.344 10.168H68.2871V18.4167H69.344V10.168Z" fill="white" />
      <path
        d="M70.2554 11.0737H72.7472V18.4167H73.8171V11.0737H76.3209V10.168H70.2554V11.0737Z"
        fill="white"
      />
      <path
        d="M83.1262 10.0332C80.9385 10.0332 79.3243 11.7462 79.3243 14.366C79.3243 16.8621 80.8451 18.551 83.0067 18.551C85.0977 18.551 86.8085 17.0459 86.8085 14.2063C86.8085 11.7593 85.3627 10.0332 83.1262 10.0332ZM83.0653 17.6825C81.4001 17.6825 80.4529 16.1041 80.4529 14.3419C80.4529 12.5305 81.3274 10.9017 83.0773 10.9017C84.8272 10.9017 85.6907 12.6158 85.6907 14.2555C85.6907 16.1281 84.7425 17.6825 83.0653 17.6825Z"
        fill="white"
      />
      <path
        d="M93.3356 10.1719V13.623C93.3356 14.9083 93.3595 15.9124 93.4562 17.0139L93.4323 17.026C93.0012 16.101 92.5099 15.2057 91.9615 14.346L89.3372 10.1719H88.1825V18.4206H89.1797V14.8918C89.1797 13.5213 89.1558 12.5302 89.0949 11.49L89.1308 11.4768C89.586 12.4251 90.0974 13.3448 90.6624 14.2312L93.2628 18.4162H94.3327V10.1719H93.3356Z"
        fill="white"
      />
      <path
        d="M52.213 13.8421H48.0592V14.9359H51.2582C51.1401 15.6418 50.795 16.2891 50.2761 16.7783C49.7572 17.2675 49.0931 17.5715 48.3859 17.6437C47.6787 17.7159 46.9675 17.5522 46.3616 17.1778C45.7558 16.8034 45.2888 16.239 45.0325 15.5713C44.7761 14.9037 44.7446 14.1697 44.9427 13.4823C45.1409 12.7948 45.5577 12.1919 46.1292 11.7662C46.7007 11.3405 47.3952 11.1156 48.1059 11.126C48.8167 11.1365 49.5044 11.3816 50.0633 11.8239L50.8356 11.0473C50.0805 10.4108 49.1323 10.0527 48.1477 10.0322C47.1632 10.0117 46.2011 10.3299 45.4204 10.9343C44.6397 11.5388 44.0871 12.3933 43.8538 13.3568C43.6205 14.3202 43.7205 15.335 44.1372 16.2335C44.554 17.132 45.2626 17.8604 46.1461 18.2986C47.0295 18.7368 48.0349 18.8584 48.9963 18.6434C49.9576 18.4285 50.8174 17.8897 51.4337 17.1162C52.0499 16.3427 52.3857 15.3807 52.3857 14.389C52.3859 14.2062 52.375 14.0235 52.3531 13.8421H52.213Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_1690_6372">
        <rect width="149.635" height="50" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const AppStoreSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="150"
    height="51"
    viewBox="0 0 150 51"
    fill="none"
  >
    <g clipPath="url(#clip0_1690_6346)">
      <path
        d="M140.955 0.25H8.50732C3.80886 0.25 0 4.09001 0 8.8269V41.6731C0 46.41 3.80886 50.25 8.50732 50.25H140.955C145.654 50.25 149.462 46.41 149.462 41.6731V8.8269C149.462 4.09001 145.654 0.25 140.955 0.25Z"
        fill="black"
      />
      <path
        d="M33.8621 26.1191C33.8613 24.8413 34.1709 23.5827 34.7641 22.4535C35.3572 21.3242 36.2158 20.3587 37.2646 19.6413C36.3255 18.4811 35.1416 17.5467 33.799 16.906C32.4565 16.2652 30.9891 15.9344 29.5038 15.9375C28.5588 15.9375 27.6441 16.2405 26.7772 16.5643C25.4579 17.0587 24.0062 17.0587 22.6869 16.5643C21.8189 16.2361 20.9064 15.9375 19.9614 15.9375C14.453 15.9375 9.98718 20.3961 9.98718 25.897C9.98718 31.398 14.453 42.2326 19.9636 42.2326C21.0702 42.2326 22.1335 41.7087 23.1295 41.3762C24.1715 41.0283 25.2969 41.0283 26.3389 41.3762C27.3338 41.7043 28.4004 42.2326 29.506 42.2326C33.0658 42.2326 36.1905 37.7052 37.9547 33.018C36.7176 32.3485 35.6837 31.3534 34.9631 30.1386C34.2424 28.9237 33.8619 27.5346 33.8621 26.1191Z"
        fill="white"
      />
      <path
        d="M29.0449 13.3585C27.6344 14.9817 25.8127 15.8743 24.2786 15.8645C24.0616 14.3331 24.7126 12.3959 26.123 10.7726C27.5335 9.14932 29.3541 8.25674 30.8883 8.26768C31.0998 9.79907 30.4564 11.7352 29.0449 13.3585Z"
        fill="white"
      />
      <path
        d="M55.4425 9.72408C54.6754 9.00433 53.5524 8.6543 52.0074 8.6543C51.236 8.65489 50.4657 8.71376 49.7029 8.83041L49.6389 8.84025V17.2574L49.7062 17.2651C50.3591 17.3356 51.0155 17.3692 51.6722 17.3657C53.3224 17.3657 54.6179 16.9391 55.4186 16.1319C56.2193 15.3246 56.6435 14.1859 56.6435 12.8033C56.6446 11.4972 56.2399 10.4613 55.4425 9.72408ZM51.8837 16.3386C51.5448 16.3444 51.2059 16.3272 50.8693 16.2872V9.76674C51.2613 9.69615 51.6591 9.66355 52.0573 9.66939C53.1542 9.66939 53.9984 9.96036 54.5658 10.5357C55.1029 11.0826 55.3719 11.856 55.3654 12.8416C55.3654 15.096 54.1286 16.3386 51.8837 16.3386Z"
        fill="white"
      />
      <path
        d="M60.5223 10.9539C60.1214 10.9449 59.7228 11.0171 59.35 11.1663C58.9773 11.3155 58.638 11.5386 58.3524 11.8224C57.773 12.4174 57.467 13.2531 57.467 14.2409C57.467 16.1179 58.68 17.4284 60.4171 17.4284C61.1866 17.4393 61.9322 17.1582 62.5057 16.6408C63.1426 16.0512 63.4822 15.1871 63.4822 14.1414C63.4822 13.2127 63.199 12.4174 62.6641 11.8443C62.1292 11.2711 61.3882 10.9539 60.5223 10.9539ZM60.4974 11.9307C61.68 11.9307 62.2182 13.0956 62.2182 14.1785C62.2182 15.4912 61.4847 16.4516 60.4724 16.4516C59.4601 16.4516 58.7267 15.5054 58.7267 14.2037C58.7267 13.0727 59.2735 11.9307 60.4974 11.9307Z"
        fill="white"
      />
      <path
        d="M70.7233 14.1822C70.5725 14.7291 70.4195 15.3012 70.311 15.8754C70.1884 15.3548 70.0354 14.8046 69.8401 14.1679L68.8962 11.0898H67.8654L66.8694 14.2303C66.7013 14.7772 66.5288 15.3471 66.3964 15.8864C66.2879 15.3515 66.1501 14.8089 66.0036 14.239L65.191 11.0898H63.915L65.7704 17.2898H66.8716L67.8568 14.3605C68.0238 13.8442 68.1975 13.2808 68.3428 12.6376C68.4763 13.225 68.6304 13.7545 68.8159 14.3473L69.749 17.2865H70.8491L72.8336 11.0898H71.5945L70.7233 14.1822Z"
        fill="white"
      />
      <path
        d="M76.8067 10.9538C76.4258 10.9444 76.0485 11.031 75.7092 11.2058C75.3699 11.3806 75.0792 11.638 74.8635 11.9547L74.8103 11.0916H73.6885L73.695 11.1737C73.7297 11.6397 73.7438 12.1275 73.7438 12.8046V17.2894H74.9861V13.5791C74.9828 13.4129 75.0067 13.2474 75.0566 13.089C75.144 12.7838 75.3264 12.515 75.5768 12.3222C75.8273 12.1294 76.1325 12.0228 76.4476 12.0181C77.5326 12.0181 77.7593 12.9479 77.7593 13.7289V17.2905H79.0016V13.6031C79.0016 11.0796 77.1734 10.9538 76.8067 10.9538Z"
        fill="white"
      />
      <path
        d="M81.8649 8.26758H80.6226V17.2908H81.8649V8.26758Z"
        fill="white"
      />
      <path
        d="M86.1637 10.9538C85.7636 10.9455 85.366 11.0181 84.9942 11.1673C84.6225 11.3164 84.2841 11.5392 83.9991 11.8223C83.4197 12.4173 83.1138 13.253 83.1138 14.2408C83.1138 16.1178 84.3268 17.4283 86.0638 17.4283C86.8334 17.4392 87.5789 17.1581 88.1524 16.6407C88.7893 16.0511 89.1289 15.187 89.1289 14.1412C89.1289 13.2126 88.8457 12.4173 88.3108 11.8442C87.7759 11.271 87.0295 10.9538 86.1637 10.9538ZM86.1387 11.9306C87.3213 11.9306 87.8595 13.0955 87.8595 14.1784C87.8595 15.4911 87.126 16.4515 86.1137 16.4515C85.1015 16.4515 84.368 15.5053 84.368 14.2036C84.368 13.0725 84.9148 11.9306 86.1387 11.9306Z"
        fill="white"
      />
      <path
        d="M94.7186 15.765V13.5029C94.7186 12.3401 94.3107 10.9531 92.3631 10.9531C91.6178 10.9531 90.8843 11.1533 90.3516 11.5001L90.3017 11.5329L90.6001 12.4079L90.6814 12.3554C91.1379 12.0708 91.6637 11.9193 92.2004 11.9179C93.0554 11.9179 93.4883 12.3631 93.4883 13.2404V13.2896C92.0832 13.2896 91.0308 13.6057 90.4427 14.1942C90.258 14.3801 90.1129 14.6022 90.0165 14.8468C89.92 15.0913 89.8742 15.3532 89.8818 15.6162C89.8818 16.4913 90.4796 17.4298 91.7925 17.4298C92.1359 17.4361 92.4764 17.3657 92.7897 17.2237C93.1029 17.0817 93.3811 16.8715 93.6044 16.6083L93.6825 17.292H94.8271L94.8109 17.2023C94.7385 16.7268 94.7076 16.2459 94.7186 15.765ZM92.0778 16.4629C91.6178 16.4629 91.1252 16.2069 91.1252 15.4893C91.1205 15.3487 91.1446 15.2085 91.1962 15.0777C91.2477 14.9469 91.3255 14.8282 91.4246 14.7291C91.7783 14.3791 92.4478 14.2019 93.4134 14.2019H93.5143V15.1765C93.5121 15.2882 93.4927 15.3989 93.4568 15.5046C93.3567 15.7914 93.169 16.0386 92.9205 16.2108C92.6721 16.383 92.3759 16.4713 92.0745 16.4629H92.0778Z"
        fill="white"
      />
      <path
        d="M101.656 15.6533V8.26758H100.414V11.7362C100.046 11.2418 99.4058 10.953 98.6561 10.953C98.313 10.9523 97.9731 11.0205 97.6564 11.1537C97.3398 11.2868 97.0526 11.4822 96.8116 11.7285C96.2105 12.3378 95.8829 13.2435 95.8894 14.2772C95.8894 16.1028 97.0004 17.4275 98.5302 17.4275C99.3765 17.4275 100.125 17.0348 100.535 16.3894L100.578 17.2897H101.711L101.704 17.2065C101.663 16.7329 101.656 16.0296 101.656 15.6533ZM98.8416 16.3883C97.5895 16.3883 97.1447 15.2256 97.1447 14.2291C97.1447 12.8771 97.8369 11.9681 98.8666 11.9681C99.2176 11.966 99.5586 12.086 99.832 12.308C100.105 12.5301 100.294 12.8404 100.367 13.1866C100.4 13.3301 100.416 13.477 100.414 13.6242V14.6743C100.417 14.8277 100.401 14.9809 100.367 15.1304C100.186 15.8852 99.5729 16.3883 98.8416 16.3883Z"
        fill="white"
      />
      <path
        d="M108.558 10.9538C108.158 10.9455 107.76 11.0181 107.389 11.1673C107.017 11.3165 106.679 11.5392 106.394 11.8223C105.814 12.4173 105.508 13.253 105.508 14.2408C105.508 16.1178 106.721 17.4283 108.459 17.4283C109.228 17.439 109.973 17.1579 110.546 16.6407C111.184 16.0511 111.523 15.187 111.523 14.1412C111.523 13.2126 111.24 12.4173 110.705 11.8441C110.17 11.271 109.423 10.9538 108.558 10.9538ZM108.533 11.9306C109.715 11.9306 110.254 13.0955 110.254 14.1784C110.254 15.4911 109.52 16.4515 108.508 16.4515C107.495 16.4515 106.762 15.5053 106.762 14.2036C106.762 13.0725 107.31 11.9306 108.533 11.9306Z"
        fill="white"
      />
      <path
        d="M115.807 10.9539C115.426 10.944 115.049 11.0303 114.709 11.2049C114.369 11.3795 114.078 11.6369 113.862 11.9537L113.814 11.0906H112.695L112.701 11.1727C112.736 11.6386 112.751 12.1265 112.751 12.8036V17.2884H113.992V13.5791C113.989 13.4129 114.013 13.2474 114.064 13.0891C114.151 12.7839 114.333 12.515 114.583 12.3221C114.834 12.1293 115.139 12.0227 115.454 12.0182C116.539 12.0182 116.765 12.948 116.765 13.729V17.2906H118.008V13.6032C118.002 11.0797 116.174 10.9539 115.807 10.9539Z"
        fill="white"
      />
      <path
        d="M123.716 9.32812L122.494 9.65628V11.0892H121.564V12.0792H122.494V15.3017C122.494 16.0947 122.634 16.6143 122.928 16.926C123.206 17.2454 123.632 17.4139 124.163 17.4139C124.502 17.4244 124.839 17.3718 125.159 17.2586L125.209 17.2378L125.15 16.2653L125.06 16.2905C124.86 16.3415 124.654 16.3658 124.448 16.3627C123.927 16.3627 123.706 16.0345 123.706 15.2688V12.0792H125.267V11.0892H123.706L123.716 9.32812Z"
        fill="white"
      />
      <path
        d="M130.84 11.4846C130.452 11.1425 129.955 10.954 129.44 10.9541C129.035 10.9579 128.638 11.0688 128.288 11.2757C128.015 11.4288 127.778 11.6401 127.595 11.8948V8.26758H126.352V17.2908H127.594V13.5717C127.583 13.4036 127.606 13.2351 127.662 13.0762C127.834 12.5555 128.331 12.0293 129.052 12.0293C130.194 12.0293 130.365 13.109 130.365 13.7522V17.3017H131.608V13.6165C131.608 12.6681 131.351 11.955 130.84 11.4846Z"
        fill="white"
      />
      <path
        d="M137.723 11.9945C137.277 11.313 136.573 10.9531 135.685 10.9531C133.985 10.9531 132.797 12.3248 132.797 14.2905C132.797 15.2148 133.075 15.9969 133.6 16.5515C134.125 17.106 134.902 17.4145 135.822 17.4145C136.804 17.4145 137.466 17.2078 137.849 17.0339L137.905 17.0076L137.688 16.0713L137.607 16.1063C137.235 16.266 136.779 16.4125 135.979 16.4125C134.786 16.4125 134.049 15.6873 134 14.4666H138.204L138.217 14.3474C138.237 14.1918 138.248 14.0351 138.249 13.8781C138.24 13.5499 138.189 12.7088 137.723 11.9945ZM134.012 13.5259C134.111 12.8805 134.54 11.8917 135.599 11.8917C135.78 11.8832 135.961 11.9122 136.13 11.9769C136.3 12.0416 136.455 12.1406 136.585 12.2679C136.973 12.6672 137.031 13.2633 137.035 13.5259H134.012Z"
        fill="white"
      />
      <path
        d="M56.1206 22.4062H53.5904L48.4053 37.7935H50.6946L52.2515 33.0396H57.3715L58.973 37.7935H61.3285L56.152 22.4992L56.1206 22.4062ZM54.8012 24.7362C54.9889 25.4767 55.1918 26.2424 55.4717 27.0726L56.8822 31.2413H52.743L54.1535 27.0475C54.3683 26.3562 54.5745 25.6134 54.8012 24.7362Z"
        fill="white"
      />
      <path
        d="M68.8344 26.42C67.2384 26.42 65.9483 27.0687 65.0836 28.3014L65.0055 26.6661H62.9766L62.9831 26.8094C63.0297 27.8945 63.072 28.9818 63.072 30.3459V42.2328H65.2778V36.5753C65.983 37.4986 67.1592 38.0389 68.5013 38.0389C69.1546 38.0459 69.8023 37.9168 70.4039 37.6597C71.0054 37.4025 71.5478 37.023 71.9971 36.5447C72.9996 35.4716 73.5302 33.9249 73.5302 32.073C73.5302 30.4629 73.0549 29.0103 72.1935 27.9897C71.783 27.4945 71.269 27.097 70.6883 26.8256C70.1075 26.5542 69.4744 26.4157 68.8344 26.42ZM68.2344 28.2632C70.3523 28.2632 71.3005 30.2212 71.3005 32.1627C71.3005 34.6644 70.1005 36.2187 68.1671 36.2187C67.5228 36.2209 66.8963 36.005 66.3882 35.6055C65.8801 35.2061 65.5196 34.6463 65.3646 34.0157C65.3118 33.7598 65.2828 33.4994 65.2778 33.238V31.3785C65.2883 31.1161 65.332 30.8562 65.408 30.6051C65.7595 29.2258 66.9215 28.2632 68.2344 28.2632Z"
        fill="white"
      />
      <path
        d="M81.4895 26.42C79.8935 26.42 78.6035 27.0687 77.7377 28.3014L77.6595 26.6661H75.6317L75.6382 26.8094C75.6849 27.8945 75.7272 28.9818 75.7272 30.3459V42.2328H77.933V36.5753C78.6371 37.4986 79.8143 38.0389 81.1564 38.0389C81.8097 38.0458 82.4574 37.9166 83.0589 37.6595C83.6605 37.4024 84.2029 37.0229 84.6522 36.5447C85.6547 35.4716 86.1842 33.9249 86.1842 32.073C86.1842 30.4629 85.7101 29.0103 84.8486 27.9897C84.4382 27.4945 83.9242 27.097 83.3434 26.8256C82.7627 26.5542 82.1296 26.4157 81.4895 26.42ZM80.8895 28.2632C83.0074 28.2632 83.9557 30.2212 83.9557 32.1627C83.9557 34.6644 82.7557 36.2187 80.8222 36.2187C80.1778 36.221 79.5512 36.0051 79.0429 35.6057C78.5345 35.2062 78.1739 34.6464 78.0187 34.0157C77.9668 33.7596 77.9381 33.4993 77.933 33.238V31.3785C77.9436 31.1162 77.987 30.8564 78.0621 30.6051C78.4147 29.2258 79.5767 28.2632 80.8895 28.2632Z"
        fill="white"
      />
      <path
        d="M97.8412 28.9634C95.6507 28.1091 94.9476 27.4321 94.9476 26.1763C94.9476 25.1175 95.7787 24.0488 97.6362 24.0488C98.6073 24.0451 99.5639 24.2873 100.418 24.7532L100.56 24.8309L101.182 22.9779L101.084 22.9221C100.588 22.6388 99.4904 22.1641 97.7034 22.1641C96.2561 22.1641 95.0094 22.5797 94.0981 23.3673C93.6613 23.7409 93.3113 24.2067 93.073 24.7319C92.8347 25.257 92.7138 25.8286 92.7191 26.406C92.7191 28.4286 94.0058 29.8309 96.7649 30.8164C98.7602 31.5909 99.5023 32.3708 99.5023 33.6933C99.5023 35.1995 98.3523 36.1358 96.5024 36.1358C95.3043 36.1228 94.1312 35.7891 93.1031 35.1689L92.9534 35.0759L92.3838 36.9803L92.4673 37.0361C93.319 37.6082 94.9628 38.0206 96.3733 38.0206C98.0615 38.0206 99.4589 37.5589 100.415 36.6839C100.847 36.2841 101.189 35.7967 101.421 35.2537C101.652 34.7107 101.767 34.1245 101.758 33.5336C101.758 32.4113 101.433 31.5034 100.76 30.7596C100.132 30.065 99.2051 29.4951 97.8412 28.9634Z"
        fill="white"
      />
      <path
        d="M106.624 23.5078L104.44 24.0952V26.6658H102.771V28.4422H104.44V34.2243C104.44 35.6463 104.692 36.5739 105.232 37.1427C105.729 37.7148 106.495 38.0178 107.444 38.0178C108.163 38.0178 108.797 37.9182 109.231 37.7377L109.321 37.7005L109.213 35.9559L109.051 35.9996C108.693 36.0906 108.325 36.1337 107.955 36.1276C107.021 36.1276 106.623 35.538 106.623 34.1587V28.4422H109.426V26.6658H106.624V23.5078Z"
        fill="white"
      />
      <path
        d="M115.919 26.4199C114.4 26.4199 113.016 26.9734 112.035 27.9798C110.993 29.0463 110.451 30.5492 110.451 32.3191C110.451 35.687 112.628 38.0388 115.747 38.0388C117.179 38.0388 118.51 37.5378 119.494 36.6267C120.638 35.5689 121.242 34.0167 121.242 32.1419C121.242 30.477 120.734 29.0484 119.774 28.0126C118.814 26.9767 117.473 26.4199 115.919 26.4199ZM115.83 36.2854C114.014 36.2854 112.696 34.5888 112.696 32.2523C112.696 30.2222 113.679 28.1734 115.875 28.1734C117.997 28.1734 118.964 30.2637 118.964 32.2075C118.964 34.5702 117.645 36.2854 115.83 36.2854Z"
        fill="white"
      />
      <path
        d="M128.329 26.4201C127.075 26.4201 125.956 27.2153 125.381 28.4798L125.325 26.6662H123.336L123.345 26.8128C123.407 27.7393 123.434 28.7817 123.434 30.1895V37.7929H125.641V31.8708C125.645 31.5706 125.674 31.2713 125.727 30.976C125.992 29.5048 126.971 28.5542 128.223 28.5542C128.437 28.5511 128.651 28.5727 128.86 28.6188L129.026 28.656V26.5175L128.917 26.4912C128.725 26.4414 128.527 26.4175 128.329 26.4201Z"
        fill="white"
      />
      <path
        d="M138.545 28.2893C137.746 27.0664 136.484 26.4199 134.89 26.4199C133.346 26.4199 132.03 27.0237 131.086 28.1701C130.196 29.2475 129.706 30.7538 129.706 32.411C129.706 34.0681 130.205 35.4737 131.148 36.4691C132.109 37.4831 133.488 38.0191 135.135 38.0191C136.897 38.0191 138.085 37.6461 138.772 37.3344L138.874 37.2873L138.477 35.6072L138.329 35.6706C137.662 35.9561 136.845 36.2176 135.4 36.2176C133.256 36.2176 131.937 34.9148 131.848 32.7238H139.392L139.405 32.6024C139.405 32.5739 139.411 32.5433 139.415 32.5094C139.451 32.2304 139.47 31.9495 139.472 31.6682C139.474 31.0797 139.384 29.5702 138.545 28.2893ZM134.735 28.1055C135.472 28.1055 136.066 28.3331 136.503 28.7815C137.201 29.498 137.303 30.5689 137.313 31.0382H131.888C132.065 29.882 132.834 28.1055 134.735 28.1055Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_1690_6346">
        <rect
          width="149.462"
          height="50"
          fill="white"
          transform="translate(0 0.25)"
        />
      </clipPath>
    </defs>
  </svg>
);


const DetailSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 23 15" fill="none">
<rect x="0.5" y="0.5" width="21.1822" height="13.4667" rx="2.5" stroke="#A19CB9"/>
<path d="M10.1622 11.5733V10.6089C10.1622 10.0973 9.959 9.60669 9.59727 9.24495C9.23553 8.88321 8.74491 8.67999 8.23334 8.67999H5.34C4.82843 8.67999 4.33781 8.88321 3.97607 9.24495C3.61433 9.60669 3.41111 10.0973 3.41111 10.6089V11.5733" stroke="#A19CB9" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M6.78667 6.75112C7.85197 6.75112 8.71556 5.88753 8.71556 4.82223C8.71556 3.75693 7.85197 2.89334 6.78667 2.89334C5.72137 2.89334 4.85778 3.75693 4.85778 4.82223C4.85778 5.88753 5.72137 6.75112 6.78667 6.75112Z" stroke="#A19CB9" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M11.5733 3.85779H18.8067" stroke="#A19CB9" strokeWidth="0.8" strokeLinecap="round"/>
<path d="M11.5733 6.26889H18.8067" stroke="#A19CB9" strokeWidth="0.8" strokeLinecap="round"/>
<path d="M11.5733 11.0911H18.8067" stroke="#A19CB9" strokeWidth="0.8" strokeLinecap="round"/>
<path d="M11.5733 8.67999H18.8067" stroke="#A19CB9" strokeWidth="0.8" strokeLinecap="round"/>
</svg>
);

export const DashboardNewAccountIcon = (props) => (
  <Icon component={DashboardNewAccSvg} {...props} />
);

export const DashboardDetailSvg = (props) => (
  <Icon component={DetailSvg} {...props} />
);

export const DashboardActivityIcon = (props) => (
  <Icon component={DashboardActSvg} {...props} />
);

export const LoginLogo = (props) => (
  <Icon component={LoginLogoSvg} {...props} />
);

export const BellIcon = (props) => <Icon component={Bell} {...props} />;

export const LifeGuardIcon = (props) => (
  <Icon component={LifeGuard} {...props} />
);
export const DividerIcon = (props) => <Icon component={Divider} {...props} />;

export const UserSvgIcon = (props) => <Icon component={UserSvg} {...props} />;
export const DashboardSvgIcon = (props) => (
  <Icon component={DashboardSvg} {...props} />
);

export const UsersSvgIcon = (props) => <Icon component={UsersSvg} {...props} />;


export const UserNavSvgIcon = (props) => (
  <Icon component={UserNavSvg} {...props} />
);
export const WorldSvgIcon = (props) => <Icon component={WorldSvg} {...props} />;

export const UserStatSvgIcon = (props) => (
  <Icon component={UserStatSvg} {...props} />
);
export const MenuSvgIcon = (props) => <Icon component={MenuSvg} {...props} />;

export const SearchSvgIcon = (props) => (
  <Icon component={SearchSvg} {...props} />
);

export const TeamsNavSvgIcon = (props) => (
  <Icon component={teamsNavSvg} {...props} />
);

export const GatewaysSvgIcon = (props) => {
  return <Icon component={gatewaysSvg} {...props} />;
};

export const EditSvgIcon = (props) => <Icon component={editSvg} {...props} />;

export const EyeSvgIcon = (props) => <Icon component={eyeSvg} {...props} />;

export const CrossEyeSvgIcon = (props) => (
  <Icon component={crosseyeSvg} {...props} />
);

export const CustomizePlanSvgIcon = (props) => (
  <Icon component={customizeplansvg} {...props} />
);

export const InvoicesNavSvgIcon = (props) => (
  <Icon component={invoiceSvg} {...props} />
);

export const EmailSvgIcon = (props) => <Icon component={EmailSvg} {...props} />;
export const ExpireTimeSvgIcon = (props) => (
  <Icon component={ExpireTimeSvg} {...props} />
);
export const MultiLoginSvgIcon = (props) => (
  <Icon component={MultiLoginSvg} {...props} />
);

export const ClockSvgIcon = (props) => <Icon component={ClockSvg} {...props} />;

export const DownloadSdkSvgIcon = (props) => (
  <Icon component={DownloadSDKSvg} {...props} />
);

export const ReportsSvgIcon = (props) => (
  <Icon component={ReportsSvg} {...props} />
);

export const KeySvgIcon = (props) => <Icon component={KeySvg} {...props} />;

export const DesignSvgIcon = (props) => <Icon component={DesignSvg} />;

export const AdditionalDetalsIcon = (props) => (
  <Icon component={AdditionalDetailsSvg} />
);

export const DevelopmentIcon = (props) => <Icon component={DevelopmentSvg} />;

export const UatIcon = (props) => <Icon component={UatSvg} />;

export const GoLiveIcon = (props) => <Icon component={GoLiveSvg} />;

export const PaymentIcon = (props) => <Icon component={PaymentSvg} />;

export const ProtectIcon = (props) => <Icon component={ProtectSvg} />;

export const PaymentMethodIcons = (props) => (
  <Icon component={PaymentMethodSvg} />
);

export const AndroidIcon = (props) => <Icon component={AndroidSvg} />;
export const IosIcon = (props) => <Icon component={IosSvg} />;

export const GooglePlayIcon = (props) => <Icon component={GooglePlaySvg} />
export const AppStoreIcon = (props) => <Icon component={AppStoreSvg}/>